/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/sub-metering-configurations": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all sub-metering-configurations */
    get: {
      parameters: {
        query?: {
          /** @description Variant id to filter for specific sub-metering configurations */
          variant?: number;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of sub-metering-configurations */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SubMeteringConfigurationResponse"][];
          };
        };
      };
    };
    put?: never;
    /** Create a new sub-metering configuration */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A sub-metering-configuration */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["SubMeteringConfiguration"];
        };
      };
      responses: {
        /** @description Creation successful, returns created sub-metering configuration */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SubMeteringConfigurationResponse"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sub-metering-configurations/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a specific sub-metering-configuration */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A specific sub-metering-configuration */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SubMeteringConfigurationGetByIDResponse"];
          };
        };
        /** @description Sub-metering-configuration not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    /** Update a specific sub-metering-configuration */
    put: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      /** @description A sub-metering-configuration */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["SubMeteringConfigurationResponse"];
        };
      };
      responses: {
        /** @description Update successful, returns sub-metering-configuration */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SubMeteringConfigurationResponse"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
      };
    };
    post?: never;
    /** Delete a specific sub-metering-configuration */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Sub-metering-configuration deleted. No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Sub-metering-configuration not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sub-metering-configurations/{ID}/set-meter-assignments": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Set meter assignments for a specific sub-metering-configuration */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      /** @description A list of meter assignments */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["MeterAssignment"][];
        };
      };
      responses: {
        /** @description Meter assignments set */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SubMeteringSystemEntityException"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sub-metering-configurations/{ID}/get-meters-parameters": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get meter parameters for a specific sub-metering-configuration */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of meter parameters */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MeterParameter"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sub-metering-configurations/{ID}/update-or-create-meter-parameters": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Starts the update or creation of meter parameters for a specific sub-metering-configuration */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Task was started, the returned url can be used to query the job status */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["JobStatus"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sub-metering-configurations/{ID}/find-meter-suggestions": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Starts the process to find meter assignment suggestions for a specific sub-metering-configuration */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Task was started, the returned url can be used to query the job status */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["JobStatus"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sub-metering-configurations/{ID}/get-meter-suggestions": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get meter assignment suggestions for a specific sub-metering-configuration. Use "find-meter-suggestions" beforehand to find suggestions */
    get: {
      parameters: {
        query: {
          /** @description ID of a task */
          task_id: components["parameters"]["TaskIDInQuery"];
        };
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description List of meter assignment suggestions */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MeterSuggestion"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sub-metering-configurations/{ID}/trigger_data_import": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Starts data import for a specific sub-metering-configuration */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      /** @description Import dates */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["ImportStartAndEndTime"];
        };
      };
      responses: {
        /** @description Task was started, the returned url can be used to query the job status */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["JobStatus"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sub-metering-configurations/{ID}/sub-metering-logs": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get sub metering import logs for a specific sub-metering-configuration */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description List of sub metering import logs */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ImportLogResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sub-metering-configurations/{ID}/check-connection": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Check the connection for a specific sub-metering-configuration */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Check successful */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Check failed with known MeteringExtractorException error */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["CheckConnectionError"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-plausibility": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Checks the plausibility of a site for a given year */
    get: {
      parameters: {
        query: {
          /** @description ID of a site */
          site: components["parameters"]["SiteInQueryRequired"];
          /** @description The start date of the interval for which to check the site's plausibility */
          start: string;
          /** @description The end date of the interval for which to check the site's plausibility */
          end: string;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Plausibility check successful */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteMeteringPlausibilityResponse"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/energy-data-warnings": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Returns energy data warnings for a variant */
    get: {
      parameters: {
        query: {
          /** @description ID of the variant to check */
          variant_id: number;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Energy data warnings successfully retrieved */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["EnergyDataWarningsResponse"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Variant not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/generation-shares": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all generation shares (for a site) */
    get: {
      parameters: {
        query?: {
          /** @description ID of a site */
          site_id?: components["parameters"]["SiteIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of generation shares and generators where generation share is missing */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GenerationShareResponse"][];
          };
        };
      };
    };
    put?: never;
    /** Create a new generation share */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A generation share */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["GenerationShareFull"];
        };
      };
      responses: {
        /** @description Creation successful, returns created generator share */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GenerationShareFull"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GenerationShareValidationError"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/generation-shares/{generator_id}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    /** Update a specific generation share */
    put: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          generator_id: components["parameters"]["GeneratorIDInPath"];
        };
        cookie?: never;
      };
      /** @description A generation share */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["GenerationShareFull"];
        };
      };
      responses: {
        /** @description Update successful, returns updated generation share */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GenerationShareFull"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GenerationShareValidationError"];
          };
        };
      };
    };
    post?: never;
    /** Delete a specific generation share */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          generator_id: components["parameters"]["GeneratorIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Generation share deleted. No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Generation share not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/metering_service_providers/{ID}/get-history": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all history log entries for a specific metering service provider */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of history log entries */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["HistoryLog"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/metering-or-market-locations/{ID}/get-history": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all history log entries for a specific metering location or market location */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of history log entries */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["HistoryLog"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/meters": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all meters for a site or variant */
    get: {
      parameters: {
        query?: {
          /** @description ID of a site */
          site?: components["parameters"]["SiteInQuery"];
          /** @description ID of a variant */
          variant_id?: components["parameters"]["VariantIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A meter list */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MeterResponse"][];
          };
        };
      };
    };
    put?: never;
    /** Create a meter */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A meter */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["MeterCreateRequest"];
        };
      };
      responses: {
        /** @description A newly created meter */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MeterResponse"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/meters/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a meter by ID */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A meter */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MeterResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update a meter by ID */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      /** @description A meter */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["MeterUpdateRequest"];
        };
      };
      responses: {
        /** @description An updated meter */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MeterResponse"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/metering-concept-meter-fields": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all meters incl. metering-concept (Messkonzept) fields for a site or variant */
    get: {
      parameters: {
        query?: {
          /** @description ID of a site */
          site?: components["parameters"]["SiteInQuery"];
          /** @description ID of a variant */
          variant_id?: components["parameters"]["VariantIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A meter list incl. metering-concept fields */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MeteringConceptMeterFieldsResponse"][];
          };
        };
      };
    };
    put?: never;
    /** Create a meter incl. metering-concept (Messkonzept) fields */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A meter incl. metering-concept fields */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["MeteringConceptMeterFieldsCreateRequest"];
        };
      };
      responses: {
        /** @description A newly created meter incl. metering-concept fields */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MeteringConceptMeterFieldsResponse"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/metering-concept-meter-fields/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a meter incl. metering-concept (Messkonzept) fields by ID */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A meter incl. metering-concept fields */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MeteringConceptMeterFieldsResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update a meter incl. metering-concept (Messkonzept) fields by ID */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      /** @description A meter incl. metering-concept fields */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["MeteringConceptMeterFieldsUpdateRequest"];
        };
      };
      responses: {
        /** @description An updated meter incl. metering-concept fields */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MeteringConceptMeterFieldsResponse"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/meters/{ID}/get-history": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all history log entries for a specific meter */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of history log entries */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["HistoryLog"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/persons/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a person by ID */
    get: operations["getPersonById"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update a person by ID */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      /** @description A person */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["Person"];
        };
      };
      responses: {
        /** @description An updated person */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Person"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/persons": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List persons on the variant */
    get: {
      parameters: {
        query?: {
          variant?: number;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of persons */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Person"][];
          };
        };
      };
    };
    put?: never;
    /** Create a person */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A person */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["Person"];
        };
      };
      responses: {
        /** @description A newly created person */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Person"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/persons/{ID}/get-history": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all history log entries for a specific person */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of history log entries */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["HistoryLog"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/consumers/{ID}/get-history": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all history log entries for a specific consumer */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of history log entries */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["HistoryLog"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/express-onboarding-generators/onboarding-status": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Status of the opti.guide steps "Konfiguration" and "Regulatorische Daten" per site
     * @description One entry per site having a generator in the express onboarding list, with the id and status of its onboarding todos "Konfiguration prüfen" and "Regulatorische Daten vervollständigen". A missing todo has no id and isn't done.
     */
    get: {
      parameters: {
        query?: {
          /** @description Filter generators by the generators accessible to this user instead of the authenticated user. The result is still limited to generators the authenticated user has access to. */
          user_id?: components["parameters"]["UserIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Status per site */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["OnboardingStatusDTO"][];
          };
        };
        /** @description Missing or invalid bearer token */
        401: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/express-onboarding-generators/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /**
     * Update the onboarding express data of a generator
     * @description Only the fields in the request body are changed. Either all of them are saved or none. anzulegender_wert and veraeusserungsform are saved as a single time slice from the eeg_inbetriebnahme of the generator on. If no generation share is stored yet, generation_share and location_id must be set together.
     */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          "application/json": components["schemas"]["GeneratorOnboardingExpressUpdateRequest"];
        };
      };
      responses: {
        /** @description The fields were saved. Returns the updated generator in the same format as the list endpoint. */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["OnboardingGeneratorDTO"];
          };
        };
        /** @description Validation errors per field of the request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": {
              [key: string]: string[];
            };
          };
        };
        /** @description Missing or invalid bearer token */
        401: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description No permission to change the generator. */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description The generator doesn't exist or isn't accessible by the user */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": {
              detail?: string;
            };
          };
        };
      };
    };
    trace?: never;
  };
  "/api/generators-single-endpoint": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a list of generators with all datas needed for a table view */
    get: {
      parameters: {
        query?: {
          site?: number;
          /** @description Filter generators by operator (Person ID) of the Direktvermarktungsvertrag */
          operator?: components["parameters"]["VermarktungsvertragCompanyInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A generator with all its data */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GeneratorList"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/generators-single-endpoint/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a all generator data by ID from a single endpoint */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A generator with all its data */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Generator"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update  all generator data by ID from a single endpoint */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      /** @description A generator with all its data */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["Generator"];
        };
      };
      responses: {
        /** @description A generator with all its data */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Generator"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/generators/{ID}/get-history": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all history log entries for a specific generator */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of history log entries */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["HistoryLog"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/generators": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a all generator data for a site or a variant */
    get: {
      parameters: {
        query?: {
          /** @description ID of a variant */
          variant_id?: components["parameters"]["VariantIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A generator list */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GeneratorOverview"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/express-onboarding-generators": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List all generators accssible by a user. */
    get: {
      parameters: {
        query?: {
          /** @description Filter generators by the generators accessible to this user instead of the authenticated user. The result is still limited to generators the authenticated user has access to. */
          user_id?: components["parameters"]["UserIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Onboarding express data */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["OnboardingGeneratorDTO"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/gas-connections/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a gas connection by ID */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A gas connection */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GasConnectionResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update a gas connection by ID */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      /** @description A gas connection */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["GasConnectionUpdateRequest"];
        };
      };
      responses: {
        /** @description An updated gas connection */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GasConnectionResponse"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/gas-connections": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all gas connections for a site */
    get: {
      parameters: {
        query?: {
          /** @description ID of a site */
          site?: components["parameters"]["SiteInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A gas connection list */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GasConnectionResponse"][];
          };
        };
      };
    };
    put?: never;
    /** Create a gas connection */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A gas connection */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["GasConnectionCreateRequest"];
        };
      };
      responses: {
        /** @description A newly created gas connection */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GasConnectionResponse"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/connections/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a connection by ID */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A connection */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ConnectionResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update a connection by ID */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      /** @description A connection */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["ConnectionUpdateRequest"];
        };
      };
      responses: {
        /** @description An updated connection */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ConnectionResponse"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/connections": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all connections for a site */
    get: {
      parameters: {
        query?: {
          /** @description ID of a site */
          site?: components["parameters"]["SiteInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A connection list */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ConnectionResponse"][];
          };
        };
      };
    };
    put?: never;
    /** Create a connection */
    post: {
      parameters: {
        query?: {
          /** @description ID of a site */
          site?: components["parameters"]["SiteInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A connection */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["ConnectionCreateRequest"];
        };
      };
      responses: {
        /** @description A newly created connection */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ConnectionResponse"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/consumers/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a consumer by ID */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A consumer */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ConsumerResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update a consumer by ID */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      /** @description A consumer */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["ConsumerUpdateRequest"];
        };
      };
      responses: {
        /** @description An updated consumer */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ConsumerResponse"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/consumers": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all consumers for a site */
    get: {
      parameters: {
        query?: {
          /** @description ID of a site */
          site?: components["parameters"]["SiteInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A consumer list */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ConsumerResponse"][];
          };
        };
      };
    };
    put?: never;
    /** Create a consumer */
    post: {
      parameters: {
        query?: {
          /** @description ID of a site */
          site?: components["parameters"]["SiteInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A consumer */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["ConsumerCreateRequest"];
        };
      };
      responses: {
        /** @description A newly created consumer */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ConsumerResponse"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/metering-concepts": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all metering concepts */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A metering concept list */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MeteringConceptResponse"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/deliveries": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List all deliveries */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of deliveries */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Delivery"][];
          };
        };
      };
    };
    put?: never;
    /** Create a new delivery */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A delivery object */
      requestBody: {
        content: {
          "application/json": components["schemas"]["Delivery"];
        };
      };
      responses: {
        /** @description Delivery created successfully */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Delivery"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/deliveries/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Retrieve a specific delivery */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A delivery object */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Delivery"];
          };
        };
        /** @description Delivery not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
      };
    };
    /** Update a specific delivery */
    put: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      /** @description A delivery object */
      requestBody: {
        content: {
          "application/json": components["schemas"]["Delivery"];
        };
      };
      responses: {
        /** @description Delivery updated successfully */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Delivery"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
        /** @description Delivery not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    post?: never;
    /** Delete a specific delivery */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Delivery deleted successfully */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Delivery not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/deliveries/{UUID}/get-history": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all history log entries for a specific invoice deliveries */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of history log entries */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["HistoryLog"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/rlm-grid-fees": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all RLM Grid Fees for a given Site ID */
    get: {
      parameters: {
        query?: {
          /** @description ID of a site */
          site?: components["parameters"]["SiteInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GridFees"];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NonFieldErrors"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/slp-grid-fees": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all SLP Grid Fees for a given Site ID */
    get: {
      parameters: {
        query?: {
          /** @description ID of a site */
          site?: components["parameters"]["SiteInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description OK */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GridFees"];
          };
        };
        /** @description Bad Request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NonFieldErrors"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/pending-invoices": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List all pending invoice requests for a project */
    get: {
      parameters: {
        query: {
          /** @description UUID of the project */
          projectId: string;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of pending invoice requests */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["PendingInvoice"][];
          };
        };
        /** @description Missing or invalid projectId parameter */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
        /** @description User does not have access to the project */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/invoice-export/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Export invoices as XLSX
     * @description Dispatches a Celery task to generate an XLSX export of invoices for the given project. When called without `task_id`, the endpoint dispatches the generation task and returns a 202 with the task ID. When called with `task_id`, it returns the generated XLSX file.
     */
    get: {
      parameters: {
        query?: {
          /** @description ID of a previously dispatched export task. When present, the endpoint returns the generated file instead of dispatching a new task. */
          task_id?: string;
          /** @description Start of the date range (inclusive). Required when `task_id` is not provided. */
          date_from?: string;
          /** @description End of the date range (inclusive). Required when `task_id` is not provided. */
          date_to?: string;
          /** @description Optional UUID of a supplier (Person) to filter invoices by. When omitted, invoices from all suppliers are included. */
          supplier_id?: string;
        };
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Generated XLSX file (when called with `task_id`) */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": string;
          };
        };
        /** @description Export task dispatched successfully */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["JobStatus"];
          };
        };
        /** @description Validation error (e.g. missing date_from/date_to) */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NonFieldErrors"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/onboarding-assistant/site-wizard/{site_id}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get onboarding wizard state for a site */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a site */
          site_id: components["parameters"]["SiteIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Onboarding wizard state for a site */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["OnboardingSiteWizardResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/onboarding-assistant/msb-documents/{site_id}/upload": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Upload an MSB Vollmacht document for a site */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a site */
          site_id: components["parameters"]["SiteIDInPath"];
        };
        cookie?: never;
      };
      requestBody: {
        content: {
          "multipart/form-data": {
            /** Format: binary */
            data_file: string;
            as_system_user?: boolean;
          };
        };
      };
      responses: {
        /** @description Uploaded MSB Vollmacht metadata */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["MSBVollmachtUploadSuccess"];
          };
        };
        /** @description Invalid upload payload */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": {
              [key: string]: unknown;
            };
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/onboarding-assistant/dataload-documents/{site_id}/upload": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Upload a Vermarkter Vollmacht for a site and person */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a site */
          site_id: components["parameters"]["SiteIDInPath"];
        };
        cookie?: never;
      };
      requestBody: {
        content: {
          "multipart/form-data": {
            /** Format: binary */
            data_file: string;
            person: number;
            as_system_user?: boolean;
          };
        };
      };
      responses: {
        /** @description Uploaded Vermarkter Vollmacht metadata */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["VermarkterVollmachtUploadSuccess"];
          };
        };
        /** @description Invalid upload payload */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["VollmachtUploadError"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/onboarding-assistant/dataload-documents/confirm": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Confirm the extracted information for an uploaded Vermarkter 'Vollmacht' */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {
        content: {
          "application/json": {
            todo_file_id: number;
            user_confirmed_extracted_data: boolean;
          };
        };
      };
      responses: {
        /** @description Successfully handled the (non-)confirmation result */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["VermarkterVollmachtConfirmationSuccess"];
          };
        };
        /** @description Invalid confirmation payload or handling the (non-)confirmation failed */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["VermarkterVollmachtConfirmationError"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/contracts": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List all contracts */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of contracts */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Contract"][];
          };
        };
      };
    };
    put?: never;
    /** Create a new contract */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A contract object */
      requestBody: {
        content: {
          "application/json": components["schemas"]["Contract"];
        };
      };
      responses: {
        /** @description Contract created successfully */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Contract"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/contracts/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Retrieve a specific contract */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A contract object */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Contract"];
          };
        };
        /** @description Contract not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    /** Update a specific contract */
    put: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      /** @description A contract object */
      requestBody: {
        content: {
          "application/json": components["schemas"]["Contract"];
        };
      };
      responses: {
        /** @description Contract updated successfully */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Contract"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
        /** @description Contract not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    post?: never;
    /** Delete a specific contract */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Contract deleted successfully */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description No permission or contract cannot be deleted due to related invoices */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Contract not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/contracts/{UUID}/get-history": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all history log entries for a specific invoice contract */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of history log entries */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["HistoryLog"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/configurator/operators": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all operators accessible by the user (potentially filtered by variant/project and whether ANY of a set of features is active for them) */
    get: {
      parameters: {
        query?: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
          /** @description ID of a variant */
          variant_id?: components["parameters"]["VariantIDInQuery"];
          /** @description If given, only include operators for which ANY of the given features are active */
          activeFeatures?: PathsApiConfiguratorOperatorsGetParametersQueryActiveFeatures[];
          /** @description If false, return only name and id of the operators, else the full persons */
          withDetails?: boolean;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of operators filtered by active features and/or project if supplied. Only return name and id if withDetails is false */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["OperatorListItem"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/erloesmonitoring/revenue-for-person": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get revenue monitoring table rows for a specific person */
    get: {
      parameters: {
        query: {
          /** @description Specify the person for which to get the revenue items */
          personId: number;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Revenue table rows, one per month */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["EnergyRevenuesListResponse"];
          };
        };
        /** @description Errors */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["UserFacingErrorWithButton"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/erloesmonitoring/revenue-for-person-default-period": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get revenue monitoring rows for a specific person of the default period */
    get: {
      parameters: {
        query: {
          /** @description Specify the person for which to get the revenue items */
          personId: number;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of revenue rows of the default period, one per month */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["EnergyRevenuesListResponse"];
          };
        };
        /** @description Errors */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["UserFacingErrorWithButton"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/erloesmonitoring/revenue-for-generators": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get revenue monitoring rows */
    get: {
      parameters: {
        query: {
          /** @description Specify a list of generators for which to get the revenue rows */
          generatorIds: number[];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of revenue table rows, one per month (multiple generators in one month already merged) */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["EnergyRevenuesListResponse"];
          };
        };
        /** @description Errors */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["UserFacingErrorWithButton"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/erloesmonitoring/cell-checks": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get cell checks states for a specific person */
    get: {
      parameters: {
        query: {
          /** @description Specify the person for which to get the cell checks states */
          personId: number;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description List of cell check states */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["EnergyRevenuesCellCheckStateResponse"][];
          };
        };
        /** @description Errors */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["UserFacingErrorWithButton"];
          };
        };
      };
    };
    put?: never;
    /** Create a new cell check state for a revenue monitoring cell */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description An object describing the state of a single cell. */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["EnergyRevenuesCellCheckState"];
        };
      };
      responses: {
        /** @description An object describing the state of a single cell. */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["EnergyRevenuesCellCheckStateResponse"];
          };
        };
        /** @description Errors */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["UserFacingErrorWithButton"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/erloesmonitoring/cell-checks/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a specific cell check state */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description An object describing the state of a single cell. */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["EnergyRevenuesCellCheckStateResponse"];
          };
        };
        /** @description Errors */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["UserFacingErrorWithButton"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    /** Delete a specific cell checkstate */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Cell check state deleted. No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Cell check state not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    options?: never;
    head?: never;
    /** Update the cell check state for a revenue monitoring cell */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      /** @description An object describing the state of a single cell. */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["EnergyRevenuesCellCheckState"];
        };
      };
      responses: {
        /** @description An object describing the state of a single cell. */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["EnergyRevenuesCellCheckStateResponse"];
          };
        };
        /** @description Errors */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["UserFacingErrorWithButton"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/erloesmonitoring/cell-checks/{UUID}/get-history": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all history log entries for a specific cell checks state entry */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of history log entries */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["HistoryLog"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-categories": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all site categories for a given project */
    get: {
      parameters: {
        query?: {
          /** @description UUID of a Project */
          project?: components["parameters"]["ProjectInQuery"];
          /** @description ID of a site */
          site?: components["parameters"]["SiteInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of site categories per site */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteCategoriesResponse"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update site categories for a given project */
    patch: {
      parameters: {
        query?: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A list of site categories per site */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["SiteCategoriesUpdateRequest"][];
        };
      };
      responses: {
        /** @description A list of site categories per site */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteCategoriesResponse"][];
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/site-categories-summary": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get site categories summary for the current user */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A dictionary of site categories */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteCategoriesSummaryResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-notifications/{site_id}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all notifications for a site */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a site */
          site_id: components["parameters"]["SiteIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of notifications for a site */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteNotification"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-status-overview": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get the status overview for all accessible sites in the default reporting year */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Site status overview data is available in the cache */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteStatusOverview"][];
          };
        };
        /** @description Site status overview data is being generated */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["JobStatus"];
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-status-overview/{year}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get the status overview for all accessible sites in a reporting year */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description Reporting year */
          year: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Site status overview data is available in the cache */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteStatusOverview"][];
          };
        };
        /** @description Site status overview data is being generated */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["JobStatus"];
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/site-status/energy_sum_overview/{person_id}/{year}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Download an XLSX energy-sum overview for a company and reporting year */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of the company */
          person_id: number;
          /** @description Reporting year */
          year: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description XLSX energy-sum overview */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": string;
          };
        };
        /** @description Unauthenticated user is redirected to the login page */
        302: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "text/html": string;
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "text/html": string;
          };
        };
        /** @description Person not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "text/html": string;
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/site-status/copy_energy_data/{site_id}/{fallback_target_year}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Copy a site's energy data from one reporting year to another */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of the site whose energy data is copied */
          site_id: number;
          /** @description Year preselected when the form is rendered */
          fallback_target_year: number;
        };
        cookie?: never;
      };
      requestBody: {
        content: {
          "multipart/form-data": {
            source_year: number;
            target_year: number;
          };
        };
      };
      responses: {
        /** @description HTML fragment containing the result or a form validation error */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "text/html": string;
          };
        };
        /** @description Unauthenticated user is redirected to the login page */
        302: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "text/html": string;
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "text/html": string;
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "text/html": string;
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-setup-assistant/site-setup-processes": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Gets the list of site setup processes with setup information (status and step) */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Returns a list of site setup processes */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteSetupProcess"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-setup-assistant/mieterstrom-data/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get data for the setup process of a Mieterstrom site */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description The data for the setup process of a Mieterstrom site */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteSetupProcessData"];
          };
        };
      };
    };
    put?: never;
    /** Write data for the setup process of a Mieterstrom site */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description The written data */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteSetupProcessData"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json":
              | components["schemas"]["ValidationErrorMessage"]
              | components["schemas"]["ValidationErrorCode"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-setup-assistant/mieterstrom-create/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** The creation of a Mieterstrom site is started */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Task was started, the returned url can be used to query the job status */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["JobStatus"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-setup-assistant/validate-plausiblilty-mieterstrom-data/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Checking (non-field) validation rules for Mieterstrom data entered in the site setup assistant */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Site setup is valid. No content */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Site setup is invalid. The response contains a list of validation error codes */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorCode"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-setup-assistant/validate-pv-plant": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Validates that a provided SEE number is valid and the corresponding pv plant exists in the Marktstammdatenregister (MaStR) database */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          "application/json": {
            /** @example SEE111111118673 */
            see_number?: string;
          };
        };
      };
      responses: {
        /** @description SEE number is valid. No content */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description SEE number is invalid. The response contains a list of validation error codes */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorCode"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-setup-assistant/create-consumers": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Returns a list of mieterstrom consumer objects based on the provided setup process data */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          "application/json": components["schemas"]["SiteSetupProcessData"];
        };
      };
      responses: {
        /** @description Valid setup process data. The response contains a list of mieterstrom consumer objects */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Consumer"][];
          };
        };
        /** @description Invalid consumer amount. The response contains a list of validation error codes */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorCode"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/site-setup-assistant/current-operator-names/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get the names of all current operators in a project */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of names of current operators */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": string[];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/tiles": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all tiles for the start page */
    get: {
      parameters: {
        query?: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of tiles */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["StartPageTile"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/sites": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all sites for the given project or for all projects of the user */
    get: {
      parameters: {
        query?: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of sites */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["StartPageSite"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/regulatory-todos": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all regulatory todos for given parameters */
    get: {
      parameters: {
        query?: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
          /** @description ID of a company */
          company_id?: components["parameters"]["CompanyIDInQuery"];
          /** @description Maximal number of items per site */
          page_size?: components["parameters"]["PageSizeInQuery"];
          /** @description Number of page, can be set to "last" */
          page?: components["parameters"]["PageInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of regulatory todos */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["PaginatedRegulatoryTodoList"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/onboarding-progress": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all onboarding todos for the given project */
    get: {
      parameters: {
        query?: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
          /** @description ID of a site */
          site_id?: components["parameters"]["SiteIDInQuery"];
          /** @description Maximal number of items per site */
          page_size?: components["parameters"]["PageSizeInQuery"];
          /** @description Number of page, can be set to "last" */
          page?: components["parameters"]["PageInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of onboarding todos */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["PaginatedOnboardingTodoList"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/delivered-electricity": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all delivered electricity for the given project */
    get: {
      parameters: {
        query: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
          /** @description year as int */
          year: components["parameters"]["YearInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description The delivered electricity */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DeliveredElectricity"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/produced-electricity": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all produced electricity for the given project/user in kWh */
    get: {
      parameters: {
        query: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
          /** @description year as int */
          year: components["parameters"]["YearInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Amount of produced electricity for the given project or all projects of the user in kWh */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": {
              /** @example 2500 */
              produced_electricity_kwh?: number;
            };
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/companies": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all companies for the given project */
    get: {
      parameters: {
        query?: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of companies */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Person"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/co2-savings": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all CO2 savings in gram since 2023 for the given project or all projects of the user */
    get: {
      parameters: {
        query: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
          /** @description year as int */
          year: components["parameters"]["YearInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description CO2 savings in gram since 2023 */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Co2Savings"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/paragraph-6-eeg": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get sum and paid amount in Euro for municipal participation for user or a project. */
    get: {
      parameters: {
        query: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
          /** @description year as int */
          year: components["parameters"]["YearInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Municipal participation in Euro */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6EEGParticipation"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/invoices": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get number of created and sent invoices for user or a project. */
    get: {
      parameters: {
        query: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
          /** @description year as int */
          year: components["parameters"]["YearInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Number of created and sent invoices */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NumberOfInvoices"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/stromsteuer": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get summary of stromsteuer forms created ready for handin. */
    get: {
      parameters: {
        query: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
          /** @description year as int */
          year: components["parameters"]["YearInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Number of created stromsteuer forms. */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": {
              /** @example 17 */
              amount_of_templates?: number;
            };
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/start-page/site-setup-processes": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all site setup processes for all or for a specific project */
    get: {
      parameters: {
        query?: {
          /** @description UUID of a Project */
          project_id?: components["parameters"]["ProjectIDInQuery"];
          /** @description Number of page, can be set to "last" */
          page?: components["parameters"]["PageInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of site setup process tile data */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["PaginatedList"] & {
              results?: components["schemas"]["SiteSetupProcessTileData"][];
            };
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/quick-search": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get quick search data for spotlight functionality
     * @description Returns comprehensive search data including sites, direktvermarktungsverträge,
     *     persons, and generators that are accessible by the current user and filtered
     *     for manager variants.
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Quick search data grouped by entity type */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["QuickSearchResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/ausfallarbeit/steuersignale": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Upload Steuerungssignale file for Ausfallarbeit */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {
        content: {
          "multipart/form-data": {
            /** Format: binary */
            file: string;
          };
        };
      };
      responses: {
        /** @description Upload successful */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["AusfallarbeitUploadResponse"];
          };
        };
        /** @description Invalid request or upload failed */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": {
              detail?: string;
            };
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/ausfallarbeit/time-series": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get Ausfallarbeit time series for one or more generators */
    get: {
      parameters: {
        query: {
          /** @description One or more generator IDs. */
          generator_ids: number[];
          /** @description Start timestamp in ISO format. */
          first_date: string;
          /** @description End timestamp in ISO format. */
          last_date: string;
          /** @description Optional filter by abregler. If omitted, all values are returned. */
          abregler?: components["schemas"]["Abregler"][];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of Ausfallarbeit time series grouped by generator and abregler */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["AusfallarbeitTimeSeries"][];
          };
        };
        /** @description Invalid request parameters */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": {
              detail?: string;
            };
          };
        };
        /** @description At least one requested generator is not registered or not accessible */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DetailMessage"];
          };
        };
        /** @description Missing or malformed query parameters */
        422: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DetailMessage"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-cancellation-generation/start-generation": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Starts the creation of a cancellation with PDF as background task and returns the job status */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description UUID of a credit */
      requestBody?: {
        content: {
          "application/json": {
            credit?: string;
          }[];
        };
      };
      responses: {
        /** @description Task was started the returned url can be used to query the job status */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["JobStatus"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-cancellations": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all cancellations accessible by the user */
    get: {
      parameters: {
        query?: {
          /** @description ID of a variant */
          variant_id?: components["parameters"]["VariantIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of cancellations */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Cancellation"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-cancellations/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a specific cancellation */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A specific cancellation */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Cancellation"];
          };
        };
        /** @description Cancellation not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": string;
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-cancellations/{UUID}/update-state": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update the state of a specific cancellation */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody: {
        content: {
          "application/json": components["schemas"]["CancellationUpdate"];
        };
      };
      responses: {
        /** @description A specific cancellation */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Cancellation"];
          };
        };
        /** @description Cancellation not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": string;
          };
        };
      };
    };
    trace?: never;
  };
  "/api/paragraph-6-eeg-cancellations/{UUID}/download": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a PDF file for a specific cancellation */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description File stream of the cancellation PDF */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/pdf": string;
          };
        };
        /** @description Cancellation PDF not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": string;
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-credits/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a credit */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A specific § 6 EEG credit */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6EEGCreditResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update a credit */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A specific § 6 EEG credit */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6EEGCreditResponse"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/paragraph-6-eeg-credits/{UUID}/get-credit-data": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get credit Data including Participation */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A specific § 6 EEG credit with Participation */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6EEGCreditDataResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-contracts/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a specific § 6 EEG contract */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A specific § 6 EEG contract */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6EEGContract"];
          };
        };
        /** @description Contract not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    /** Delete a specific § 6 EEG contract */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Contract deleted. No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Contract not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    options?: never;
    head?: never;
    /** Update a specific § 6 EEG contract */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      /** @description A § 6 EEG contract */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["Paragraph6EEGContract"];
        };
      };
      responses: {
        /** @description The updated § 6 EEG contract */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6EEGContract"];
          };
        };
        /** @description Contract not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/paragraph-6-eeg-contracts": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all § 6 EEG contracts */
    get: {
      parameters: {
        query?: {
          /** @description ID of a variant */
          variant_id?: components["parameters"]["VariantIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of contracts */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6EEGContract"][];
          };
        };
      };
    };
    put?: never;
    /** Create a § 6 EEG contract */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A § 6 EEG contract */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["Paragraph6EEGContract"];
        };
      };
      responses: {
        /** @description A § 6 EEG contract */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6EEGContract"];
          };
        };
        /** @description Bad request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-contracts/{UUID}/gemeinde-anteile-erzeuger": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create a gemeinde anteil erzeuger for a specific § 6 EEG contract */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      /** @description An anteil */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["GemeindeAnteilErzeuger"];
        };
      };
      responses: {
        /** @description The created anteil */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GemeindeAnteilErzeuger"];
          };
        };
        /** @description Bad request */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** @description Contract or Generator not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-contracts/{UUID}/gemeinde-anteile-erzeuger/{generator_id}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a specific anteil for a specific contract */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
          generator_id: components["parameters"]["GeneratorIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description An anteil */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GemeindeAnteilErzeuger"];
          };
        };
        /** @description Contract or GemeindeAnteilErzeuger not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    /** Update a specific anteil for a specific contract */
    put: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
          generator_id: components["parameters"]["GeneratorIDInPath"];
        };
        cookie?: never;
      };
      /** @description An anteil */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["GemeindeAnteilErzeuger"];
        };
      };
      responses: {
        /** @description The updated anteil */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GemeindeAnteilErzeuger"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** @description Contract or Generator not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    post?: never;
    /** Delete a specific generator share for a specific contract */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
          generator_id: components["parameters"]["GeneratorIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Generator share deleted. No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    options?: never;
    head?: never;
    /** Update a specific anteil for a specific contract */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
          generator_id: components["parameters"]["GeneratorIDInPath"];
        };
        cookie?: never;
      };
      /** @description An anteil */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["GemeindeAnteilErzeuger"];
        };
      };
      responses: {
        /** @description The updated anteil */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GemeindeAnteilErzeuger"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** @description Contract or Generator not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/paragraph-6-eeg-contracts/{UUID}/unassigned-generators": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all generator shares for unassigned generators for a specific contract */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of template generator shares */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6UnassignedGeneratorsResponse"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-contracts/list-companies": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all companies */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of companies */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Person"][];
          };
        };
        /** @description No companies found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-contracts/allowed-variables": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all allowed variables for a § 6 EEG formula */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of allowed variables */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": string[];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-credit-generation/get-draft-credit": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Starts the creation of a credit draft as background task and returns the job status */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: {
        content: {
          "application/json": components["schemas"]["CreditRequest"];
        };
      };
      responses: {
        /** @description Task was started the returned url can be used to query the job status */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["JobStatus"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-credit-generation/list-creatable-credits": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Return a list of credits that could be created now. */
    get: {
      parameters: {
        query: {
          variant: number;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Success */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["CreditRequest"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-credit-generation/list-non-creatable-credits": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Return a list of credits that can't be created now because of missing data or parameters. */
    get: {
      parameters: {
        query: {
          variant: number;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Success */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["CreditPeriodCheckResult"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/paragraph-6-eeg-credit-number-ranges": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all § 6 EEG credit number ranges */
    get: {
      parameters: {
        query?: {
          /** @description ID of a variant */
          variant_id?: components["parameters"]["VariantIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of credit number ranges */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6EEGCreditNumberRangeResponse"][];
          };
        };
      };
    };
    put?: never;
    /** Create a § 6 EEG credit number range */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A § 6 EEG credit number range */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["Paragraph6EEGCreditNumberRange"];
        };
      };
      responses: {
        /** @description The created credit number range */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6EEGCreditNumberRangeResponse"];
          };
        };
        /** @description Collision of credit number ranges */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    /** Delete a specific § 6 EEG credit number range */
    delete: {
      parameters: {
        query?: {
          /** @description UUID of a credit number range */
          credit_number_range_id?: components["parameters"]["CreditNumberRangeIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Credit number range deleted. No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Credit number range not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    options?: never;
    head?: never;
    /** Update an existing § 6 EEG credit number range */
    patch: {
      parameters: {
        query?: {
          /** @description UUID of a credit number range */
          credit_number_range_id?: components["parameters"]["CreditNumberRangeIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description An existing § 6 EEG credit number range with changes */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["Paragraph6EEGCreditNumberRange"];
        };
      };
      responses: {
        /** @description The updated credit number range */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Paragraph6EEGCreditNumberRangeResponse"];
          };
        };
        /** @description Collision of credit number ranges */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/direktvermarktungsvertraege": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all Direktvermarktung contracts */
    get: {
      parameters: {
        query?: {
          /** @description ID of a variant */
          variant_id?: components["parameters"]["VariantIDInQuery"];
          /** @description If true, only return contracts that are currently valid. Cannot be combined with 'expired' or 'upcoming'. */
          active?: boolean;
          /** @description If true, only return contracts whose validity has ended. Cannot be combined with 'active' or 'upcoming'. */
          expired?: boolean;
          /** @description If true, only return contracts that will become valid in the future. Cannot be combined with 'active' or 'expired'. */
          upcoming?: boolean;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of contracts with their name and id */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungContractOverviewResponse"][];
          };
        };
        /** @description The active and expired filters cannot both be true */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
        /** @description Variant not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    put?: never;
    /** Create a new Direktvermarktung contract */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A Direktvermarktung contract */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["DirektvermarktungContract"];
        };
      };
      responses: {
        /** @description Creation successful, returns created contract */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungContractResponse"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungContractValidationError"];
          };
        };
        /** @description Operator not found. The response has no body. */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/direktvermarktungsvertraege/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a specific Direktvermarktung contract */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A specific Direktvermarktung contract */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungContractResponse"];
          };
        };
        /** @description Contract not found. The response has no body. */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    /** Update a specific Direktvermarktung contract */
    put: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      /** @description A Direktvermarktung contract */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["DirektvermarktungContract"];
        };
      };
      responses: {
        /** @description Update successful, returns updated contract */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungContractResponse"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungContractValidationError"];
          };
        };
        /** @description Contract or operator not found. The response has no body. */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    post?: never;
    /** Delete a specific Direktvermarktung contract */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Contract deleted. No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Contract not found. The response has no body. */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/direktvermarktungsvertraege/{UUID}/extend": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Extend the validity of a Direktvermarktung contract */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      /** @description The new last date of the contract */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["DirektvermarktungContractExtension"];
        };
      };
      responses: {
        /** @description Extension successful, returns the updated contract */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungContractResponse"];
          };
        };
        /** @description The contract cannot be extended to the given date */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungContractValidationError"];
          };
        };
        /** @description Contract not found. The response has no body. */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/direktvermarktungsvertraege/{UUID}/get-history": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all history log entries for a specific Direktvermarktung contract */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of history log entries */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["HistoryLog"][];
          };
        };
        /** @description Contract not found. The response has no body. */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/direktvermarktungsvertraege/{UUID}/unassigned-generators": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all unassigned generation shares for a specific contract */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /**
         * @description A list of unassigned generators as generation shares with
         *     existing share data if available
         */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungUnassignedGeneratorsResponse"][];
          };
        };
        /** @description Contract not found. The response has no body. */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/direktvermarktungsvertraege/{UUID}/generation-shares": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Create a new Direktvermarktung generator share */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      /** @description A Direktvermarktung generator share */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["DirektvermarktungGeneratorShare"];
        };
      };
      responses: {
        /** @description Creation successful, returns created generator share */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungGeneratorShareResponse"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungGeneratorShareValidationError"];
          };
        };
        /** @description Contract not found. The response has no body. */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/direktvermarktungsvertraege/{UUID}/generation-shares/{generator_id}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete a specific Direktvermarktung generator share */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
          generator_id: components["parameters"]["GeneratorIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Generator share deleted. No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Contract not found. The response has no body. */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    options?: never;
    head?: never;
    /** Attach an existing generator share to the contract */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
          generator_id: components["parameters"]["GeneratorIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Attach successful, returns the attached generator share */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarktungGeneratorShareResponse"];
          };
        };
        /**
         * @description Either per field validation errors, or a single user facing message in
         *     `detail` if the generator cannot be registered for the Erlösmonitoring
         *     because required generator fields are missing.
         */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json":
              | components["schemas"]["DirektvermarktungGeneratorShareValidationError"]
              | components["schemas"]["DetailMessage"];
          };
        };
        /** @description No existing generator share found for the given generator. The response has no body. */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    trace?: never;
  };
  "/api/direktvermarktungsvertraege/allowed-variables": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all allowed variables for the different formulas */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description The allowed variables for each of the formulas saved on the contract */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["FormulaVariablesResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/oauth/applications": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all OAuth applications */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of OAuth applications */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["OAuthApplicationResponse"][];
          };
        };
      };
    };
    put?: never;
    /** Create a new OAuth application */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description An OAuth application */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["OAuthApplicationCreate"];
        };
      };
      responses: {
        /** @description Creation successful, returns created application */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["OAuthApplicationCreateResponse"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/oauth/applications/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete a specific OAuth application */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Application deleted. No Content */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Application not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/oauth/applications/{UUID}/regenerate-client-secret": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Regenerate the client secret of a specific OAuth application */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description The newly generated client secret */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["OAuthApplicationRegenerateClientSecretResponse"];
          };
        };
        /** @description Application not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/oauth/applications/options-for-create": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all options for creating an OAuth application */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description An object containing the options */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["OAuthApplicationOptionsForCreateResponse"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/meter-data-gaps/data": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all contiguous gaps in metering data for the given meter and time span */
    get: {
      parameters: {
        query: {
          /** @description id of a meter */
          meter: components["parameters"]["MeterIdInQuery"];
          /** @description First date for a time-limited resource */
          first_date: components["parameters"]["FirstDateInQuery"];
          /** @description Last date for a time-limited resource */
          last_date: components["parameters"]["LastDateInQuery"];
          /** @description The unit for the measured data */
          unit: components["parameters"]["UnitInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A dictionary containing a list of gaps and the measurand value for each measurand of a meter. Also contains the expected origin of meter data. */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GapsInMeteringData"];
          };
        };
        /** @description ValidationError */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/location-data-gaps": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all contiguous gaps in metering data for the given metering or market location and time span */
    get: {
      parameters: {
        query: {
          /** @description id of a metering or market location */
          location: number;
          /** @description First date for a time-limited resource */
          first_date: string;
          /** @description Last date for a time-limited resource */
          last_date: string;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A dictionary containing a list of gaps and the measurand value for each measurand of a location. */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["GapsInMeteringData"];
          };
        };
        /** @description ValidationError */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/data-import-requests/{UUID}/support": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Request support for a data import request */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody: {
        content: {
          "application/json": components["schemas"]["DataImportRequestSupportRequest"];
        };
      };
      responses: {
        /** @description Support requested, returns the updated data import request */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DataImportRequest"];
          };
        };
        /** @description Validation error. The body is validated before the lookup, so an invalid body returns 400 even for an unknown ID. */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidatedObject"];
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Data import request not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NotFound"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/profile": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get the profile user */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description The profile user */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ExtendedUser"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/users/me": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get the current user */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description The current user */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["CurrentUser"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/users/system": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all system users */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description An array of system users */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["User"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/users/active": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all active users (staff only) */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description An array of active users with their organization name */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ActiveUser"][];
          };
        };
        /** @description No permission to list users. */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/onboarding-assistant/metering-concept-todos": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all metering concept todos for the given project */
    get: {
      parameters: {
        query: {
          /** @description ID of a site */
          site: components["parameters"]["SiteInQueryRequired"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description A list of ids and labels for metering concept todos */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["TodoLabel"][];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/todos/{ID}/can-generate-documents": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Check if documents can be generated for a specific todo */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Returns a object if documents can be generated and why not */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["TodosCanGenerateDocuments"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/todos/update-user-decisions": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update user decisions for todos */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description A list of todos and their decisions */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["TodosUpdateUserDecisions"];
        };
      };
      responses: {
        /** @description A list of updated todos */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["TodoDetail"][];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/todo-calendars": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List todo calendar integrations */
    get: {
      parameters: {
        query?: {
          /** @description ID of a variant */
          variant_id?: components["parameters"]["VariantIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Returns list of calendar integrations */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["TodoCalendarIntegration"][];
          };
        };
      };
    };
    put?: never;
    /** Create a new todo calendar integration */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {
        content: {
          "application/json": components["schemas"]["TodoCalendarIntegrationCreate"];
        };
      };
      responses: {
        /** @description Calendar integration created */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["TodoCalendarIntegration"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/todo-calendars/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete a todo calendar integration */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Calendar integration deleted */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/todo-calendars/{ID}/refresh": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Refresh a todo calendar integration (regenerate UUID) */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Calendar integration refreshed */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["TodoCalendarIntegration"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/todo-notes": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List todo notes */
    get: {
      parameters: {
        query?: {
          /** @description ID of the todo to list the notes for */
          todo?: number;
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Returns list of notes, newest first */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["TodoNote"][];
          };
        };
        /** @description The todo does not exist or is not accessible */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidationErrorMessage"];
          };
        };
      };
    };
    put?: never;
    /** Create a todo note */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {
        content: {
          "application/json": components["schemas"]["TodoNoteCreate"];
        };
      };
      responses: {
        /** @description Note created */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["TodoNote"];
          };
        };
        /** @description Invalid note or inaccessible todo */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidatedObject"];
          };
        };
        /** @description Only staff can create notes as system user */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/todo-notes/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Delete a todo note */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Note deleted */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description Only the author can delete a note */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Note not found or not accessible */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NotFound"];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/todo-notes/{ID}/perform-todo-note-update": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Update a todo note */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody: {
        content: {
          "application/json": components["schemas"]["TodoNoteUpdate"];
        };
      };
      responses: {
        /** @description Note updated */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["TodoNote"];
          };
        };
        /** @description Invalid note */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidatedObject"];
          };
        };
        /** @description Only staff can change whether a note is internal, and only the author can update a note */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Note not found or not accessible */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NotFound"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/mk-export": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Download the metering-concept (Messkonzept) PDF
     * @description Second step of the two-step export. Returns the PDF generated by the task dispatched with `POST`.
     */
    get: {
      parameters: {
        query: {
          /** @description ID of a task */
          task_id: components["parameters"]["TaskIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description The generated metering-concept PDF */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/pdf": string;
          };
        };
        /** @description Missing `task_id` or the task did not finish successfully */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": {
              task_id: string;
            };
          };
        };
      };
    };
    put?: never;
    /**
     * Start the metering-concept (Messkonzept) PDF export
     * @description First step of the two-step export. Dispatches a Celery task that renders the metering-concept PDF for a site and returns a 202 with the task ID. Poll the returned task status URL, then download the PDF with `GET` and the `task_id`.
     */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody: {
        content: {
          "multipart/form-data": {
            site: number;
            /** Format: binary */
            image: string;
            upload_to_todo: boolean;
          };
        };
      };
      responses: {
        /** @description Export task dispatched; the returned URL can be used to query the job status */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["JobStatus"];
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidatedObject"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/metering-data-export/download": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Download a Excel sheet with metering data */
    get: {
      parameters: {
        query: {
          /** @description ID of a task */
          task_id: components["parameters"]["TaskIDInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description a Excel sheet with metering data */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Download"];
          };
        };
      };
    };
    put?: never;
    /** Starts the creation of a excel with metering data as background task and returns the job status */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description requesting metering data */
      requestBody?: {
        content: {
          "application/json": {
            meter: number;
            first_date: string;
            last_date: string;
          };
        };
      };
      responses: {
        /** @description Task was started the returned url can be used to query the job status */
        202: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["JobStatus"];
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Meter not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": {
              detail?: string;
            };
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/variants/{VariantID}": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description The ID of the variant */
        VariantID: number;
      };
      cookie?: never;
    };
    /** Get infos on variant with given ID */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description The ID of the variant */
          VariantID: number;
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Infos on variant with given ID */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["VariantDetail"];
          };
        };
        /** @description Variant not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update variant */
    patch: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description The ID of the variant */
          VariantID: number;
        };
        cookie?: never;
      };
      requestBody?: {
        content: {
          "application/json": components["schemas"]["VariantDetail"];
        };
      };
      responses: {
        /** @description Updated variant */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["VariantDetail"];
          };
        };
        /** @description Variant not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    trace?: never;
  };
  "/api/sites": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get all sites */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Sites attached */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteResponse"][];
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
      };
    };
    put?: never;
    /** Create a new site */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description Site to be created */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["SiteCreationRequest"];
        };
      };
      responses: {
        /** @description Site created */
        201: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteResponse"];
          };
        };
        /** @description Validation failed */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidatedObject"];
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Referenced object not found or not accessible */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NotFound"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sites/{ID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get a site */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Site attached */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteResponse"];
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    /** Update a site */
    put: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      /** @description Site updates */
      requestBody?: {
        content: {
          "application/json": components["schemas"]["SiteUpdateRequest"];
        };
      };
      responses: {
        /** @description Site updated */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["SiteResponse"];
          };
        };
        /** @description Validation failed */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["ValidatedObject"];
          };
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    post?: never;
    /** Delete a site */
    delete: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Site deleted */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sites/{ID}/activate-invoicing": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Activate invoicing */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Invoicing activated */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sites/{ID}/deactivate-invoicing": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Deactivate invoicing */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Invoicing deactivated */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sites/{ID}/activate-metering-concept-v2": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Activate metering concept v2 */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Metering concept v2 activated */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sites/{ID}/deactivate-metering-concept-v2": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Deactivate metering concept v2 */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Metering concept v2 deactivated */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sites/{ID}/activate-go": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Activate Go */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Go activated */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sites/{ID}/deactivate-go": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Deactivate Go */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Go deactivated */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sites/{ID}/set-license/{SiteLicense}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Set license */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
          /** @description license of the site */
          SiteLicense: components["parameters"]["SiteLicenseInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description License set */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sites/{ID}/activate-premium-todos": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Activate premium todos */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Premium todos activated */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/sites/{ID}/deactivate-premium-todos": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Deactivate premium todos */
    post: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description ID of a resource */
          ID: components["parameters"]["IDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Premium todos deactivated */
        204: {
          headers: {
            [name: string]: unknown;
          };
          content?: never;
        };
        /** @description No permission */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["Error"];
          };
        };
      };
    };
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/advance-payments-calculate/{UUID}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Calculated installment amount */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path: {
          /** @description UUID of a resource */
          UUID: components["parameters"]["UUIDInPath"];
        };
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Calculated installment amount */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": {
              /** @example 1000 */
              installment: number;
            };
          };
        };
        /** @description Validation error */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": PathsApiAdvancePaymentsCalculateUUIDGetResponses400ContentApplicationJson[];
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/energy-data-availability": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get energy data availability for a site and period */
    get: {
      parameters: {
        query: {
          /** @description ID of a site */
          site: components["parameters"]["SiteInQueryRequired"];
          /** @description First date for a time-limited resource */
          first_date: components["parameters"]["FirstDateInQuery"];
          /** @description Last date for a time-limited resource */
          last_date: components["parameters"]["LastDateInQuery"];
        };
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description Energy data availability for the site */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["EnergyAvailabilityDataType"];
          };
        };
        /** @description Error during request from missing parameters, incorrectly formatted dates, or domain-specific errors. */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json":
              | {
                  detail: string;
                }
              | components["schemas"]["NonFieldErrors"];
          };
        };
        /** @description Site not found */
        404: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": {
              detail: string;
            };
          };
        };
      };
    };
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/api/external/direktvermarkter": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List all Direktvermarkter known to optinode
     * @description Returns every Direktvermarkter mirrored from Hubspot, including those marked inactive (date_inactive_since set).
     */
    get: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      requestBody?: never;
      responses: {
        /** @description List of Direktvermarkter known to optinode */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarkterExternal"][];
          };
        };
        /** @description Missing or invalid bearer token */
        401: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Token is missing the marktteilnehmer:read scope, or does not belong to an internal OAuth client */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
      };
    };
    /**
     * Synchronize Direktvermarkter from Hubspot
     * @description Upserts every Direktvermarkter in the payload by hubspot_id. Any existing, currently active Direktvermarkter whose hubspot_id is not part of the payload is marked inactive (date_inactive_since set to now). Payload must not contain duplicate hubspot_id or name values. The update is atomic: if any item fails validation or violates a database constraint, no changes are persisted.
     */
    put: {
      parameters: {
        query?: never;
        header?: never;
        path?: never;
        cookie?: never;
      };
      /** @description The full, current list of Direktvermarkter in Hubspot */
      requestBody: {
        content: {
          "application/json": components["schemas"]["DirektvermarkterWriteRequest"][];
        };
      };
      responses: {
        /** @description Synchronization successful, returns the synchronized Direktvermarkter */
        200: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarkterExternal"][];
          };
        };
        /** @description Payload is not a list, an item is missing hubspot_id/name, hubspot_id or name are duplicated within the payload, or the payload conflicts with an existing Direktvermarkter */
        400: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["DirektvermarkterBulkUpdateError"];
          };
        };
        /** @description Missing or invalid bearer token */
        401: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
        /** @description Token is missing the marktteilnehmer:write scope, or does not belong to an internal OAuth client */
        403: {
          headers: {
            [name: string]: unknown;
          };
          content: {
            "application/json": components["schemas"]["NoPermission"];
          };
        };
      };
    };
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    /** @description A request to import energy data from an uploaded file */
    DataImportRequest: {
      /** Format: uuid */
      id: string;
      variant: number | null;
      is_edm_upload: boolean;
      /** Format: date-time */
      created: string;
      /** Format: date-time */
      updated: string;
      user: string | null;
      energy_data_file: components["schemas"]["EnergyDataFile"];
      status: components["schemas"]["DataImportRequestStatus"];
      type_of_data: components["schemas"]["DataImportRequestType"];
      error_message: string | null;
      celery_task_id: string;
      support_requested: boolean;
      selected_meter: number | null;
      /** Format: uuid */
      selected_origin: string | null;
      count: number;
      new_origin_name: string | null;
    };
    SubMeteringConfiguration: {
      client_id?: string;
      name: string;
      password?: string;
      sub_metering_system?: components["schemas"]["SubMeteringSystem"];
      token?: string;
      /** Format: uri */
      url?: string;
      username?: string;
      variant?: number;
    };
    SubMeteringConfigurationImportLog: components["schemas"]["ImportLog"];
    SubMeteringConfigurationMeterParameter: components["schemas"]["MeterParameter"];
    SubMeteringConfigurationMeterAssignment: components["schemas"]["MeterAssignment"];
    SubMeteringConfigurationMeterSuggestion: components["schemas"]["MeterSuggestion"];
    /** @description A log entry that records a specific action (create, update, delete) performed on a database model at a  precise timestamp. */
    HistoryLog: {
      /** @description Unique identifier */
      id: number;
      /**
       * @description Which action was performed on a database model: 0 = Created, 1 = Updated, 2 = Deleted
       * @enum {integer}
       */
      action: HistoryLogAction;
      /**
       * @description The name of the user who made the change. It can be `null` if no user is associated with the change.
       * @example Max Mustermann
       */
      user: string | null;
      /**
       * Format: date-time
       * @description The timestamp of when the change was made. It's represented as a string in the format "DD.MM.YYYY HH:MM:SS".
       * @example 17.09.2024 16:04:23
       */
      timestamp: string;
      changes: components["schemas"]["Changes"];
      /**
       * @description A string representation of the affected object.
       * @example PV-Anlage Buxtehude
       */
      object_label: string;
      /**
       * @description Any additional data associated with the change. This can be `null` or an object containing  various key-value pairs.
       * @example {
       *       "extra_information": "Aus dem Marktstammdatenregister importiert."
       *     }
       */
      additional_data?: {
        [key: string]: string;
      } | null;
    };
    /**
     * @description An object representing the changes made. Each key is the name of the changed property,  and the value is a two-element array containing the old value and the new value. Old and new values can either be strings or arrays of objects.
     * @example {
     *       "bruttoleistung": [
     *         "1972.48",
     *         "1972.4"
     *       ],
     *       "name": [
     *         "None",
     *         "PV-Anlage Buxtehude"
     *       ],
     *       "base_prices": [
     *         [
     *           {
     *             "value": 150,
     *             "first_date": null,
     *             "last_date": null
     *           }
     *         ],
     *         [
     *           {
     *             "value": 1000,
     *             "first_date": null,
     *             "last_date": "23.09.2024"
     *           },
     *           {
     *             "value": 1022,
     *             "first_date": "26.09.2024",
     *             "last_date": null
     *           }
     *         ]
     *       ]
     *     }
     */
    Changes: {
      [key: string]: string[] | components["schemas"]["DateBoundedValue"][][];
    };
    /** @description Represents a value with a validity date range */
    DateBoundedValue: {
      /** @example 1000.0 */
      value: string | boolean;
      /**
       * Format: date
       * @example 2024-09-24
       */
      first_date: string | null;
      /**
       * Format: date
       * @example 2024-09-23
       */
      last_date: string | null;
    };
    /** @description A UUID to a resource */
    UUID: {
      /** @example ARealLongUUID1234 */
      id: string;
    };
    OnboardingSiteWizardResponse: {
      id: number;
      enabled: boolean;
      onboarding_done: {
        onboarding_done?: boolean;
        todo_status?: {
          mbk_todo?: boolean;
          msb_data_todo?: boolean;
          regulatory_todo?: boolean;
        };
      };
      phases: {
        configuration: components["schemas"]["OnboardingPhase"];
        regulatory: components["schemas"]["OnboardingPhase"];
        dataloadauthority: components["schemas"]["OnboardingPhase"];
        msbauthority: components["schemas"]["OnboardingPhase"];
        invoices: components["schemas"]["OnboardingPhase"];
      };
    };
    OnboardingPhase: {
      /** @example Konfiguration */
      name: string;
      objects_are_missing: boolean;
      done: boolean;
      missing_data: {
        id?: number;
        name?: string;
        /** @example default */
        missing_data_type?: string;
        /** @example Person */
        component_name?: string;
        missing_fields?: string[];
      }[];
      has_missing_documents?: boolean;
      display_phase?: boolean;
      exclusive_or_fields?: string[][];
    };
    JobStatus: {
      task_status_url?: string;
      task_ids?: string[];
      errors?: string[];
    };
    SiteStatusOverview: {
      id: number;
      name: string;
      cache_key?: number;
    } & {
      [key: string]: unknown;
    };
    /** @enum {string|null} */
    RepresentationType: RepresentationType;
    /** @enum {string|null} */
    LegalStructureType: LegalStructureType;
    Cancellation: {
      /** Format: uuid */
      credit: string;
      document_name: string;
      state: components["schemas"]["CancellationState"];
      id?: string;
      credit_number?: string;
      supplier?: string;
      community_name?: string;
      /** Format: date-time */
      creation_date?: string | null;
      /** Format: date */
      billing_period_start?: string;
      /** Format: date */
      billing_period_end?: string;
    };
    CancellationUpdate: {
      state: components["schemas"]["CancellationState"];
    };
    /** @enum {string} */
    CancellationState: CancellationState;
    OAuthApplication: {
      name: string;
      customer: number;
      scope: components["schemas"]["OAuthApplicationScope"][];
    };
    OAuthApplicationCreate: components["schemas"]["OAuthApplication"];
    OAuthApplicationResponse: components["schemas"]["OAuthApplication"] & {
      readonly id: string;
      readonly created: string;
      readonly is_valid: boolean;
      readonly client_id: string;
    };
    OAuthApplicationCreateResponse: components["schemas"]["OAuthApplication"] & {
      readonly id: string;
      readonly client_id: string;
      readonly client_secret: string;
    };
    OAuthApplicationRegenerateClientSecretResponse: {
      readonly client_secret: string;
    };
    OAuthApplicationOptionsForCreateResponse: {
      readonly customers: {
        [key: string]: string;
      };
      readonly scope: components["schemas"]["OAuthApplicationScope"][];
    };
    /** @enum {string} */
    OAuthApplicationScope: OAuthApplicationScope;
    CreditRequest: {
      /** Format: uuid */
      contract: string;
      /** Format: date */
      start_date: string;
      /** Format: date */
      end_date: string;
      draft?: boolean;
      fiktive_strommengen_are_imprecise?: boolean;
      data_completeness_percentage: number;
    };
    CreditPeriodCheckResult: {
      billing_period: components["schemas"]["CreditRequest"];
      energy_data_check_failed: boolean;
      master_data_check_failed: boolean;
      exactly_one_grid_operator_check_failed: boolean;
      eeg_anlage_incomplete: {
        id?: number;
        name?: string;
        site_id?: number;
        name_with_site?: string;
      }[];
      netztransparenz_values_missing: components["schemas"]["NetztransparenzDataCheck"];
      generators_with_incomplete_veraeusserungsformen: {
        id?: number;
        name?: string;
        site_id?: number;
        name_with_site?: string;
      }[];
    };
    /** @description Represents the completeness check for Netztransparenz data */
    NetztransparenzDataCheck: {
      /** @description List of missing Jahresmarktwerte (PV, Wind) with list of missing years */
      jahresmarktwerte_missing: components["schemas"]["NetztransparenzMissingValue"][];
      /** @description List of missing Monatsmarktwerte (PV, Wind) with list of missing months */
      monatsmarktwerte_missing: components["schemas"]["NetztransparenzMissingValue"][];
      /** @description List of missing ClaimForRemunerationRules (§ 51) with list of missing months */
      p51_rules_missing: components["schemas"]["NetztransparenzMissingValue"][];
    };
    NetztransparenzMissingValue: {
      /** @description Human readable label of the missing data (e.g. "Jahresmarktwert (PV)") */
      label: string;
      /** @description One or more year (optionally narrowed by months) ranges indicating missing data */
      periods: components["schemas"]["YearOrMonths"][];
    };
    YearOrMonths: {
      year: number;
      /** @description Optional list of missing months (1-12) within the year */
      months?: number[];
    };
    /** @enum {string} */
    DirektvermarktungContractTrAbrechnungsmodell: DirektvermarktungContractTrAbrechnungsmodell;
    DirektvermarktungContractOverviewResponse: {
      /** Format: uuid */
      readonly id: string;
      readonly name: string;
      readonly operator_id?: number | null;
      /** Format: date */
      readonly first_date?: string | null;
      /** Format: date */
      readonly last_date?: string | null;
      readonly direktvermarkter_id?: number | null;
      readonly is_extendable: boolean;
    };
    DirektvermarktungContractValidationError: {
      name?: components["schemas"]["ValidationErrorMessage"];
      operator?: components["schemas"]["ValidationErrorMessage"];
      direktvermarkter?: components["schemas"]["ValidationErrorMessage"];
      contract_remuneration_type?: components["schemas"]["ValidationErrorMessage"];
      first_date?: components["schemas"]["ValidationErrorMessage"];
      last_date?: components["schemas"]["ValidationErrorMessage"];
    };
    DirektvermarktungGeneratorShare: components["schemas"]["GenerationShareFull"] & {
      /** Format: uuid */
      contract_id: string;
    };
    DirektvermarktungGeneratorShareResponse: {
      generator_display_name: string;
      generator_id: number;
      metering_or_market_location_display_name: string;
      metering_or_market_location_id: number | null;
      site_id: number;
      /** Format: float */
      weighting: string | null;
      /** Format: uuid */
      readonly contract_id: string;
      readonly generator_name: string;
      readonly is_redispatch_import_active?: boolean;
    };
    DirektvermarktungUnassignedGeneratorsResponse: {
      /** Format: uuid */
      readonly contract_id: string;
      generator_id: number;
      readonly generator_display_name: string;
      /** Format: float */
      weighting?: string | null;
      readonly site_id: number;
      metering_or_market_location_id?: number | null;
      readonly metering_or_market_location_display_name?: string | null;
    };
    DirektvermarktungGeneratorShareValidationError: {
      generator_id?: components["schemas"]["ValidationErrorMessage"];
      metering_or_market_location_id?: components["schemas"]["ValidationErrorMessage"];
      weighting?: components["schemas"]["ValidationErrorMessage"];
    };
    FormulaVariablesResponse: {
      [key: string]: string[];
    };
    User: {
      id: number;
      name: string;
      image: string | null;
    } & {
      [key: string]: unknown;
    };
    ExtendedUser: components["schemas"]["User"] & {
      email?: string;
    };
    CurrentUser: components["schemas"]["ExtendedUser"] & {
      admin_url: string | null;
      chat_enabled: boolean;
      has_analyzer_license: boolean;
      has_api_settings_access: boolean;
      has_manager_license: boolean;
      is_staff: boolean;
      userpilot_enabled: boolean;
      date_joined: string;
      is_beta_user: boolean;
      groups: CurrentUserGroups[];
    };
    /** @enum {string} */
    SubMeteringSystem: SubMeteringSystem;
    SubMeteringConfigurationResponse: components["schemas"]["SubMeteringConfiguration"] & {
      readonly id: number;
    };
    /** @description A list of validation error messages */
    ValidationErrorMessage: string[];
    FieldSettings: {
      type: string;
      required: boolean;
      read_only: boolean;
      label: string;
      allow_null: boolean;
    };
    FieldSettingsWithHelpText: components["schemas"]["FieldSettings"] & {
      help_text: string;
      max_length: number;
    };
    FieldSettingsWithChoices: components["schemas"]["FieldSettings"] & {
      choices: {
        value: string;
        display_name: string;
      }[];
    };
    SubMeteringConfigurationGetByIDResponse: {
      name?: string;
      description?: string;
      renders?: string[];
      parses?: string[];
      actions?: {
        PUT?: {
          id?: components["schemas"]["FieldSettings"];
          variant?: components["schemas"]["FieldSettings"];
          name?: components["schemas"]["FieldSettingsWithHelpText"];
          sub_metering_system?: components["schemas"]["FieldSettingsWithChoices"];
          url?: components["schemas"]["FieldSettingsWithHelpText"];
          username?: components["schemas"]["FieldSettingsWithHelpText"];
          password?: components["schemas"]["FieldSettings"];
          token?: components["schemas"]["FieldSettings"];
          client_id?: components["schemas"]["FieldSettingsWithHelpText"];
        };
      };
    };
    Error: {
      /**
       * @description A human readable error message
       * @example Api error message maybe user facing
       */
      message: string;
    };
    MeterAssignment: {
      sub_metering_system_entity_id: number;
      meter_id?: number;
    };
    SubMeteringSystemEntityException: {
      error: string;
      extra_info: Record<string, never>;
    };
    MeterParameter: {
      id: number;
      meter?: number | null;
      parameters: Record<string, never>;
      sub_metering_configuration: number;
    };
    MeterSuggestion: {
      sub_metering_entity_id: number;
      suggested_meter_id: number;
    };
    ImportStartAndEndTime: {
      /**
       * Format: date-time
       * @example 2024-06-01T00:00:00.000+02:00
       */
      start: string;
      /**
       * Format: date-time
       * @example 2024-06-07T00:00:00.000+02:00
       */
      end: string;
    };
    ImportLog: {
      id: number;
      sub_metering_configuration: number;
      meter?: number | null;
      sub_metering_system: components["schemas"]["SubMeteringSystem"];
      url?: string | null;
      username?: string;
      /** Format: date-time */
      start_date?: string | null;
      /** Format: date-time */
      end_date?: string | null;
      /** Format: date-time */
      timestamp: string;
      /** @enum {string} */
      message_type: ImportLogMessage_type;
      message?: string | null;
      exception_name?: string | null;
      status_code?: number | null;
      original_message?: string | null;
    };
    ImportLogResponse: {
      /** @description The total number of items available. */
      count: number;
      /**
       * Format: uri
       * @description The URL to the next page of results, if any.
       */
      next?: string | null;
      /**
       * Format: uri
       * @description The URL to the previous page of results, if any.
       */
      previous?: string | null;
      /** @description The list of SubMeteringConfigurationImportLog items for the current page. */
      results: components["schemas"]["ImportLog"][];
    };
    CheckConnectionError: {
      error: string;
    };
    MeteringPlausibilityResponse: {
      /** @description A list of checks that failed for consumption */
      failed_consumption_checks: string[];
      /** @description A list of checks that failed for generation */
      failed_generation_checks: string[];
      /** @description The unique identifier for the meter */
      meter_id: number;
      /** @description The plausibility status of the meter, can be null */
      plausibility: boolean | null;
    };
    SiteMeteringPlausibilityResponse: components["schemas"]["MeteringPlausibilityResponse"][];
    EnergyDataWarningsResponse: {
      /** @description Count of meters with unplausible data */
      num_implausible_meters: number;
      /** @description Year for which the energy data warnings are reported */
      reporting_year: number;
    };
    NoPermission: {
      detail?: string;
    };
    GenerationShareResponse: {
      generator_id: number;
      readonly generator_display_name: string;
      readonly site_id: number;
      readonly current_operator?: string;
      metering_or_market_location_id?: number | null;
      readonly metering_or_market_location_display_name?: string | null;
      /** Format: float */
      weighting?: string | null;
    };
    GenerationShareFull: {
      generator_display_name: string;
      generator_id: number;
      metering_or_market_location_display_name: string;
      metering_or_market_location_id: number | null;
      site_id: number;
      /** Format: float */
      weighting: string | null;
    };
    GenerationShareValidationError: {
      generator_id?: components["schemas"]["ValidationErrorMessage"];
      metering_or_market_location?: components["schemas"]["ValidationErrorMessage"];
      weighting?: components["schemas"]["ValidationErrorMessage"];
    };
    /**
     * @description Medium
     * @enum {string}
     */
    MeterMedium: MeterMedium;
    /**
     * @description Intervall der Messwerte
     * @enum {string}
     */
    MeterFrequency: MeterFrequency;
    /**
     * @description Erfassung der Energiemengen
     * @enum {string}
     */
    MeterEnergyMeasurementType: MeterEnergyMeasurementType;
    /**
     * @description Messrichtung
     * @enum {string}
     */
    MeterMeteringDirection: MeterMeteringDirection;
    /**
     * @description Untermess-System
     * @enum {string|null}
     */
    MeterSubMeteringSystem: MeterSubMeteringSystem | null;
    /** @enum {string|null} */
    YesNoChoice: YesNoChoice | null;
    /** @description All data of a meter */
    MeterResponse: {
      id: number;
      /**
       * Format: uuid
       * @description Globally unique identifier of the meter (Globale ID)
       */
      global_id: string;
      /** @description ID of the site (Liegenschaft) the meter belongs to */
      site: number;
      /** @description Bezeichnung */
      name: string;
      /** @description Zählernummer bzw. Seriennummer */
      number: string | null;
      medium: components["schemas"]["MeterMedium"];
      frequency: components["schemas"]["MeterFrequency"];
      measurement_type: components["schemas"]["MeterEnergyMeasurementType"];
      metering_direction: components["schemas"]["MeterMeteringDirection"];
      /** @description Human-readable label for the metering direction */
      metering_direction_label: string;
      /** @description ID of the Mess- oder Marktlokation Einspeisung, if any */
      location_feedin: number | null;
      /** @description ID of the Mess- oder Marktlokation Entnahme, if any */
      location_feedout: number | null;
      sub_metering_system: components["schemas"]["MeterSubMeteringSystem"];
      is_calibrated: components["schemas"]["YesNoChoice"];
      /**
       * Format: date
       * @description Ablaufdatum der Eichgültigkeit
       */
      calibration_valid_until: string | null;
      /**
       * Format: float
       * @description Wandlerfaktor
       */
      conversion_factor: number | null;
      /** @description ID of the related consumption share, if any */
      consumption_share: number | null;
    };
    SketchElement: {
      x_position: number;
      y_position: number;
    };
    /** @description Data for creating a meter */
    MeterCreateRequest: {
      /**
       * Format: uuid
       * @description Globally unique identifier of the meter (Globale ID); generated if omitted
       */
      global_id?: string;
      /** @description ID of the site (Liegenschaft) the meter belongs to */
      site: number;
      /** @description Bezeichnung */
      name: string;
      /** @description Zählernummer bzw. Seriennummer */
      number?: string | null;
      medium: components["schemas"]["MeterMedium"];
      frequency?: components["schemas"]["MeterFrequency"];
      measurement_type: components["schemas"]["MeterEnergyMeasurementType"];
      metering_direction: components["schemas"]["MeterMeteringDirection"];
      /** @description ID of the Mess- oder Marktlokation Einspeisung, if any */
      location_feedin?: number | null;
      /** @description ID of the Mess- oder Marktlokation Entnahme, if any */
      location_feedout?: number | null;
      sub_metering_system?: components["schemas"]["MeterSubMeteringSystem"];
      is_calibrated?: components["schemas"]["YesNoChoice"];
      /**
       * Format: date
       * @description Ablaufdatum der Eichgültigkeit
       */
      calibration_valid_until?: string | null;
      /**
       * Format: float
       * @description Wandlerfaktor
       */
      conversion_factor?: number | null;
      sketch_element: components["schemas"]["SketchElement"];
    };
    /** @description Data for updating a meter */
    MeterUpdateRequest: {
      id: number;
      /**
       * Format: uuid
       * @description Globally unique identifier of the meter (Globale ID)
       */
      global_id?: string;
      /** @description ID of the site (Liegenschaft) the meter belongs to */
      site?: number;
      /** @description Bezeichnung */
      name?: string;
      /** @description Zählernummer bzw. Seriennummer */
      number?: string | null;
      medium?: components["schemas"]["MeterMedium"];
      frequency?: components["schemas"]["MeterFrequency"];
      measurement_type?: components["schemas"]["MeterEnergyMeasurementType"];
      metering_direction?: components["schemas"]["MeterMeteringDirection"];
      /** @description ID of the Mess- oder Marktlokation Einspeisung, if any */
      location_feedin?: number | null;
      /** @description ID of the Mess- oder Marktlokation Entnahme, if any */
      location_feedout?: number | null;
      sub_metering_system?: components["schemas"]["MeterSubMeteringSystem"];
      is_calibrated?: components["schemas"]["YesNoChoice"];
      /**
       * Format: date
       * @description Ablaufdatum der Eichgültigkeit
       */
      calibration_valid_until?: string | null;
      /**
       * Format: float
       * @description Wandlerfaktor
       */
      conversion_factor?: number | null;
    };
    /**
     * @description The voltage levels of a grid connection point (Netzverknuepfungspunkt)
     * @enum {string|null}
     */
    VoltageLevel: VoltageLevel | null;
    /** @description Additional metering-concept-specific fields stored on a meter (premium Messkonzept). All fields are optional and may be null. */
    MeteringConceptMeterFieldsExtraFields: {
      /**
       * @description Bezeichnung (was wird gemessen)
       * @enum {string|null}
       */
      measurement_description?: MeteringConceptMeterFieldsExtraFieldsMeasurement_description | null;
      /**
       * @description Messart
       * @enum {string|null}
       */
      measuring_method?: MeteringConceptMeterFieldsExtraFieldsMeasuring_method | null;
      voltage?: components["schemas"]["VoltageLevel"];
      /** @description Einbauort */
      installation_location?: string | null;
      /**
       * Format: date
       * @description Einbaudatum
       */
      installation_date?: string | null;
      /**
       * Format: float
       * @description Jahresverbrauch (für PV-Anlage geschätzte Erzeugung) in kWh/Jahr
       */
      yearly_consumption?: number | null;
      /**
       * @description Tariftyp
       * @enum {string|null}
       */
      tariff_type?: MeteringConceptMeterFieldsExtraFieldsTariff_type | null;
      /**
       * @description Bilanzierungsrelevanter Zähler oder Unterzähler
       * @enum {string|null}
       */
      meter_billing_relevant_or_submeter?: MeteringConceptMeterFieldsExtraFieldsMeter_billing_relevant_or_submeter | null;
      /**
       * @description Aufhängung
       * @enum {string|null}
       */
      aufhaengung?: MeteringConceptMeterFieldsExtraFieldsAufhaengung | null;
      /** @description Absicherung in Ampere (elektr. Stromstärke) */
      absicherung_in_ampere?: number | null;
    };
    /** @description All data of a meter including premium metering-concept (Messkonzept) fields */
    MeteringConceptMeterFieldsResponse: components["schemas"]["MeterResponse"] &
      components["schemas"]["MeteringConceptMeterFieldsExtraFields"];
    /** @description Data for creating a meter including premium metering-concept (Messkonzept) fields */
    MeteringConceptMeterFieldsCreateRequest: components["schemas"]["MeterCreateRequest"] &
      components["schemas"]["MeteringConceptMeterFieldsExtraFields"];
    /** @description Data for updating a meter including premium metering-concept (Messkonzept) fields */
    MeteringConceptMeterFieldsUpdateRequest: components["schemas"]["MeterUpdateRequest"] &
      components["schemas"]["MeteringConceptMeterFieldsExtraFields"];
    Email: {
      email_address?: string;
    };
    Participation: {
      id: number;
      value: boolean;
      /** Format: date */
      first_date: string | null;
      /** Format: date */
      last_date: string | null;
    };
    /** @enum {string|null} */
    SupplierStatus: SupplierStatus | null;
    VersorgerstatusPeriod: {
      status: components["schemas"]["SupplierStatus"];
      /** Format: date */
      first_date: string | null;
      /** Format: date */
      last_date: string | null;
    };
    Person: {
      additional_invoice_supplied_emails?: components["schemas"]["Email"][];
      address?: string;
      address_extra?: string;
      /** Format: float */
      besondere_ausgleichsregelung_eeg?: number | null;
      /** Format: float */
      besondere_ausgleichsregelung_kwk?: number | null;
      /** Format: float */
      besondere_ausgleichsregelung_offshore?: number | null;
      city?: string;
      color?: string;
      company_number?: string | null;
      contact?: string | null;
      customs_office?: string | null;
      din_en16247_1_installed?: components["schemas"]["YesNoChoice"];
      din_en_iso_50001_installed?: components["schemas"]["YesNoChoice"];
      electricity_consumption_over_50_gwh_per_year?: components["schemas"]["YesNoChoice"];
      electricity_or_energy_tax_relief_10_stromstg_or_55_energiestg?: components["schemas"]["YesNoChoice"];
      emas_installed?: components["schemas"]["YesNoChoice"];
      energy_tax_relief_51_energiestg?: components["schemas"]["YesNoChoice"];
      energy_tax_relief_54_energiestg?: components["schemas"]["YesNoChoice"];
      forestry_or_agriculture?: components["schemas"]["YesNoChoice"];
      general_partner_ceo?: string | null;
      general_partner_city?: string | null;
      general_partner_court?: string | null;
      general_partner_name?: string | null;
      general_partner_register_number?: string | null;
      id?: number;
      invoice_recipient?: string | null;
      is_invoicing_active?: boolean;
      invoice_supplied_accounting_area?: string | null;
      invoice_supplied_address?: string | null;
      invoice_supplied_address_extra?: string | null;
      invoice_supplied_address_is_general_address?: components["schemas"]["YesNoChoice"];
      invoice_supplied_bank?: string | null;
      invoice_supplied_bic?: string | null;
      invoice_supplied_business_area?: string | null;
      invoice_supplied_business_reference?: string | null;
      invoice_supplied_city?: string | null;
      invoice_supplied_cost_center?: string | null;
      invoice_supplied_customer_number?: string | null;
      invoice_supplied_debit_number?: string | null;
      invoice_supplied_email?: string | null;
      invoice_supplied_global_id?: string | null;
      invoice_supplied_iban?: string | null;
      invoice_supplied_information?: string | null;
      invoice_supplied_information_category?: string | null;
      invoice_supplied_profit_center?: string | null;
      invoice_supplied_psp_element?: string | null;
      invoice_supplied_target_accounting_area?: string | null;
      invoice_supplied_zip?: string | null;
      invoice_supplier_bank?: string | null;
      invoice_supplier_bic?: string | null;
      invoice_supplier_ceo?: string | null;
      invoice_supplier_court?: string | null;
      invoice_supplier_creditor_id?: string | null;
      invoice_supplier_email?: string | null;
      invoice_supplier_fax?: string | null;
      invoice_supplier_iban?: string | null;
      invoice_supplier_identification_graphic?: string | null;
      invoice_supplier_identification_graphic_year?: number | null;
      invoice_supplier_is_gbr?: components["schemas"]["YesNoChoice"];
      invoice_supplier_location?: string | null;
      invoice_supplier_logo?: string | null;
      invoice_supplier_phone?: string | null;
      invoice_supplier_register_number?: string | null;
      invoice_supplier_sales_tax_id?: string | null;
      invoice_supplier_tax_number?: string | null;
      invoice_supplier_template?: number | null;
      invoice_supplier_url?: string | null;
      is_erloesmonitoring_active?: boolean;
      is_redispatch_import_active?: boolean;
      is_in_mieterstrom_project?: boolean;
      is_internal_supplier?: components["schemas"]["YesNoChoice"];
      is_mieter?: boolean | null;
      is_paragraph_6_eeg_active?: boolean;
      is_solar_contractor?: boolean;
      is_strompbg_calculator_active?: boolean;
      is_yearly_report_of_tax_reliefs_required?: components["schemas"]["YesNoChoice"];
      makes_use_of_beihilfen_strompreiskompensation?: components["schemas"]["YesNoChoice"];
      makes_use_of_besondere_ausgleichsregelung?: components["schemas"]["YesNoChoice"];
      makes_use_of_exempts_over_500_000_per_year?: components["schemas"]["YesNoChoice"];
      manufacturing_industry?: components["schemas"]["YesNoChoice"];
      mastr_nummer_marktakteur?: string | null;
      name: string;
      participations_in_mieterstrom_model?: components["schemas"]["Participation"][];
      /** Format: float */
      pension_salaries_paid?: number | null;
      sites_where_active?:
        | {
            id?: number;
            name?: string;
          }[]
        | null;
      sites_where_was_operator?:
        | {
            id?: number;
            name?: string;
          }[]
        | null;
      should_regulatory_duties_be_checked?: boolean;
      small_medium_enterprise?: components["schemas"]["YesNoChoice"];
      versorgerstatus_periods?: components["schemas"]["VersorgerstatusPeriod"][];
      supply_electricity_tax_monthly?: components["schemas"]["YesNoChoice"];
      tax_forms_applicant_address_supplement?: string | null;
      tax_forms_applicant_city?: string | null;
      tax_forms_applicant_city_district?: string | null;
      tax_forms_applicant_country?: string | null;
      /** Format: date */
      tax_forms_applicant_date_of_birth_or_foundation?: string | null;
      tax_forms_applicant_house_number?: string | null;
      tax_forms_applicant_legal_structure?:
        (string | null) | components["schemas"]["LegalStructureType"];
      tax_forms_applicant_name?: string | null;
      tax_forms_applicant_number?: string | null;
      tax_forms_applicant_other_city?: string | null;
      tax_forms_applicant_residence_or_office?: string | null;
      tax_forms_applicant_street?: string | null;
      tax_forms_applicant_transaction_number_electricity_tax?: string | null;
      tax_forms_applicant_zip?: string | null;
      tax_forms_bank_account_bic?: string | null;
      tax_forms_bank_account_holder?: string | null;
      tax_forms_bank_account_iban?: string | null;
      tax_forms_company_represented_by?: number | null;
      tax_forms_contact_email?: string | null;
      tax_forms_contact_fax?: string | null;
      tax_forms_contact_name?: string | null;
      tax_forms_contact_phone?: string | null;
      tax_forms_contact_website?: string | null;
      tax_forms_representation_type?:
        (string | null) | components["schemas"]["RepresentationType"];
      tax_forms_submission_in_own_name?: boolean;
      unternehmen_in_schwierigkeiten_years?: string[];
      variant?: number;
      zip?: string;
    };
    /** @description Status of the onboarding todos of the opti.guide steps "Konfiguration" and "Regulatorische Daten" of a site. A todo id is null if the site has no such todo yet, it isn't done then (api/express-onboarding-generators/onboarding-status -> OnboardingStatusDTO) */
    OnboardingStatusDTO: {
      site_id: number;
      /** @description ID of the onboarding todo "Konfiguration prüfen" */
      configuration_todo_id: number | null;
      configuration_todo_done: boolean;
      /** @description ID of the onboarding todo "Regulatorische Daten vervollständigen" */
      regulatory_duty_todo_id: number | null;
      regulatory_duty_todo_done: boolean;
    };
    /** @enum {string|null} */
    FoerderRegime: FoerderRegime | null;
    /**
     * @description Type of Veraeusserungsform
     * @enum {string|null}
     */
    Veraeusserungsform: Veraeusserungsform | null;
    /** @description Only the given fields are changed, unknown fields are ignored. */
    GeneratorOnboardingExpressUpdateRequest: {
      tr_id?: string | null;
      sr_id?: string | null;
      foerderregime?: components["schemas"]["FoerderRegime"];
      /**
       * Format: date
       * @description Only for EEG-Anlagen with Gebotstermin (Wind, Solar, Biomasse). The Jahr des Gebotstermins is set to its year.
       */
      gebotstermin?: string | null;
      /** @description ct/kWh. Set as a single value from the eeg_inbetriebnahme on; null deletes it. Not possible if the EEG-Anlage has several anzulegende Werte or one covering another period than from the eeg_inbetriebnahme on. */
      anzulegender_wert?: number | null;
      /** @description Set as a single value from the eeg_inbetriebnahme on; null deletes it. Not possible if the generator has several Veräußerungsformen or one covering another period than from the eeg_inbetriebnahme on. */
      veraeusserungsform?: components["schemas"]["Veraeusserungsform"];
      /** Format: date */
      eeg_inbetriebnahme?: string | null;
      /** @description Share of the generator in the Mess- oder Marktlokation (Aufteilungsfaktor), required together with location_id if no generation share is stored yet */
      generation_share?: number;
      /** @description ID of the Mess- oder Marktlokation (Zählpunkt), required together with generation_share if no generation share is stored yet */
      location_id?: number;
    };
    /** @description Data of a generator in express onboarding list and update requests (api/express-onboarding-generators -> OnboardingGeneratorDTO) */
    OnboardingGeneratorDTO: {
      id: number;
      name: string;
      site_id: number;
      site_name: string;
      project_id: string;
      project_name: string;
      tr_id?: string | null;
      sr_id?: string | null;
      mastr_nr?: string | null;
      foerderregime?: components["schemas"]["FoerderRegime"];
      jahr_des_gebotstermins?: number | null;
      /** Format: date */
      gebotstermin?: string | null;
      anzulegender_wert?: number | null;
      veraeusserungsform?: components["schemas"]["Veraeusserungsform"];
      /** Format: date */
      eeg_inbetriebnahme?: string | null;
      generation_share?: number | null;
      /** @description ID of the metering or market location, if any */
      location_id?: number | null;
      /** @description The fields that can't be edited in the express onboarding given the stored data, with the reason to show to the user. Absent fields are editable. */
      uneditable_fields: {
        tr_id?: string;
        sr_id?: string;
        foerderregime?: string;
        gebotstermin?: string;
        jahr_des_gebotstermins?: string;
        eeg_inbetriebnahme?: string;
        anzulegender_wert?: string;
        veraeusserungsform?: string;
      };
    };
    /**
     * @description The type of a generators
     * @enum {string}
     */
    GeneratorType: GeneratorType;
    DateRange: {
      /** Format: date */
      upper: string | null;
      /** Format: date */
      lower: string | null;
    } | null;
    /** @enum {string|null} */
    EEGVersionDetailed: EEGVersionDetailed | null;
    GeneratorList: {
      id: number;
      name: string;
      type?: components["schemas"]["GeneratorType"];
      installed_capacity?: number;
      /** Format: date */
      commissioning?: string;
      /** Format: date */
      decommissioning?: string | null;
      einheit_mastr_nummer?: string;
      person?: string;
      person_id?: number;
      sr_id?: string | null;
      tr_id?: string | null;
      anlagenschluessel_eeg?: string;
      /** Format: date */
      eeg_inbetriebnahmedatum?: string | null;
      anzulegender_wert?: number | null;
      count_anzulegender_werte?: number | null;
      foerderregime?: components["schemas"]["FoerderRegime"];
      jahr_des_gebotstermins?: number | null;
      /** Format: date */
      gebotstermin?: string | null;
      veraeusserungsform?: components["schemas"]["Veraeusserungsform"];
      stfrei_paragraph_9_abs_1_nr_1_stromstg?: components["schemas"]["YesNoChoice"];
      /** Format: date */
      datum_erlaubnis_stfrei_paragraph_9_abs_1_nr_1_stromstg?: string | null;
      einzelerlaubnis_steuerfreie_entnahme_zur_stromerzeugung?: components["schemas"]["YesNoChoice"];
      /** Format: date */
      datum_einzelerlaubnis_steuerfreie_entnahme_zur_stromerzeugung?:
        string | null;
      stromstg_paragraph_9_1_3a?: components["schemas"]["YesNoChoice"];
      zeitraum_stromstg_paragraph_9_1_3a?: components["schemas"]["DateRange"];
      stromstg_paragraph_9_1_3b?: components["schemas"]["YesNoChoice"];
      zeitraum_stromstg_paragraph_9_1_3b?: components["schemas"]["DateRange"];
      is_redispatch_import_active?: boolean | null;
      is_redispatch_import_active_for_operator?: boolean | null;
      site_name?: string | null;
      /** @description Human-readable description of the applied § 51 EEG rule */
      applied_p51_rule?: string | null;
      eeg_version?: components["schemas"]["EEGVersionDetailed"];
      p51_rule_is_relevant?: boolean;
    }[];
    OperationPeriod: {
      company: number;
      /** Format: date */
      first_date: string;
      /** Format: date */
      last_date: string | null;
    };
    AnlageBase: {
      im_mastr_registriert: boolean;
      mastr_nummer: string;
      foerderregime: components["schemas"]["FoerderRegime"];
      bnetza_registrierungsnummer: string | null;
      hersteller_typ: string | null;
      kategorie_eeg_umlage_eigenverbrauch: string | null;
      messlokation_id: string | null;
      wind_park_regler_zentral_steuern: components["schemas"]["YesNoChoice"];
      steuerbefreiung_strom_zur_stromerz_paragraph_9_abs_2_stromstg: components["schemas"]["YesNoChoice"];
    };
    /** @description Details for the anzulegender Wert of a generator. */
    AnzulegenderWert: {
      /** Format: date */
      first_date: string;
      /** Format: date */
      last_date?: string | null;
      /** Format: decimal */
      price_ct_per_kwh: string | null;
    } | null;
    /** @description Represents a Veraeusserungsform with validity date range */
    VeraeusserungsformPeriod: {
      /**
       * Format: date
       * @description Start date of the Veraeusserungsform
       */
      first_date: string;
      /**
       * Format: date
       * @description End date of the Veraeusserungsform
       */
      last_date?: string | null;
      veraeusserungsform: components["schemas"]["Veraeusserungsform"];
    };
    /** @description Selected data of a generator for a list entry for paragraph 24. */
    Paragraph24GeneratorListEntry: {
      id: number;
      name: string;
      type?: string;
      installed_capacity?: number;
      /** Format: date */
      eeg_inbetriebnahmedatum?: string;
      site_name?: string;
    };
    Paragraph24Zusammenfassung: {
      summed_capacity?: number;
      default_generators?: components["schemas"]["Paragraph24GeneratorListEntry"][];
      custom_generator_ids?: number[] | null;
      warning?: string;
    };
    EEGAnlage: components["schemas"]["AnlageBase"] &
      ({
        anlagenschluessel_eeg: string | null;
        /** Format: date */
        eeg_inbetriebnahmedatum: string;
        installierte_leistung: number | null;
        anzulegender_wert: components["schemas"]["AnzulegenderWert"][] | null;
        veraeusserungsformen?:
          components["schemas"]["VeraeusserungsformPeriod"][] | null;
        paragraph_24_zusammenfassung?: components["schemas"]["Paragraph24Zusammenfassung"];
        /** @description Human-readable description of the applied § 51 EEG rule */
        applied_p51_rule?: string | null;
        eeg_version?: components["schemas"]["EEGVersionDetailed"];
        p51_rule_is_relevant?: boolean;
      } | null);
    EEGAnlageBiomasse: components["schemas"]["EEGAnlage"] & {
      jahr_des_gebotstermins: number | null;
      /**
       * Format: date
       * @description Datum der Leistungserhöhung
       */
      biogas_datum_leistungserhoehung: string | null;
      /** @description Umfang der Leistungserhöhung */
      biogas_umfang_leistungserhoehung: number | null;
      /**
       * Format: date
       * @description Datum des erstmaligen ausschließlichen Einsatzes von Biomethan
       */
      biomethan_erstmaliger_einsatz: string | null;
      /** @description Betriebsstatus der Anlage */
      anlage_betriebsstatus: string | null;
    };
    EEGAnlageGSGK: components["schemas"]["EEGAnlage"] & {
      /** @description Betriebsstatus der Anlage */
      anlage_betriebsstatus: string | null;
    };
    EEGAnlageSolar: components["schemas"]["EEGAnlage"] & {
      jahr_des_gebotstermins: number | null;
      /** Format: date */
      gebotstermin?: string | null;
      /** @description Installierte Leistung der EEG-Anlage in kW */
      installierte_leistung: number | null;
      /** @description Anlagenschlüssel EEG */
      anlagenschluessel_eeg: string | null;
      /** @description Anlagenkennziffer aus dem Anlagenregister */
      anlagenkennziffer_anlagenregister: string | null;
      /** @description Registrierungsnummer (PV-Melderegister) */
      registrierungsnummer_pv_meldeportal: string | null;
      /** @description Inanspruchnahme von Zahlungen nach §19 EEG */
      inanspruchnahme_zahlung_nach_eeg: boolean | null;
      /** @description Zuschlag erlangt */
      ausschreibung_zuschlag: boolean | null;
      /** @description Zuschlagsnummern (PV) */
      zuschlagsnummer: string | null;
      zugeordnete_gebotsmenge: number;
      /** @description Mieterstrom angemeldet */
      mieterstrom_zugeordnet: boolean | null;
      /**
       * Format: date
       * @description Datum der erstmaligen Zuordnung zur Veräußerungsform des Mieterstromzuschlags
       */
      mieterstrom_erste_zuordnung_zuschlag?: string | null;
      /**
       * Format: date
       * @description Meldedatum Mieterstrom
       */
      mieterstrom_meldedatum?: string | null;
      /** @description Betriebsstatus der Anlage */
      anlage_betriebsstatus: string | null;
    };
    EEGAnlageWind: components["schemas"]["EEGAnlage"] & {
      jahr_des_gebotstermins: number | null;
      /** Format: date */
      gebotstermin?: string | null;
      anlagenschluessel_eeg: string;
      installierte_leistung: number;
    };
    EEGAnlageWasser: components["schemas"]["EEGAnlage"] & {
      /** @description Installierte Leistung der EEG-Anlage in kW */
      installierte_leistung: number | null;
      /** @description Anlagenschlüssel EEG */
      anlagenschluessel_eeg: string | null;
      /** @description Anlagenkennziffer aus dem Anlagenregister */
      anlagenkennziffer_anlagenregister: string | null;
      /** @description Betriebsstatus der Anlage */
      anlage_betriebsstatus: string | null;
    };
    KWKAnlage: components["schemas"]["AnlageBase"] &
      ({
        vorrichtungen_abwaermeabfuhr: components["schemas"]["YesNoChoice"];
        elektrische_kwk_leistung: number;
        /** Format: date */
        inbetriebnahmedatum: string;
        mech_energie_stromerzeugung_paragraph_3_abs_1_nr_1_energiestg: components["schemas"]["YesNoChoice"];
        hocheffizient: components["schemas"]["YesNoChoice"];
        energiesteuerentlastung_paragraph_53_energiestg: components["schemas"]["YesNoChoice"];
        /** @enum {string|null} */
        energiesteuerentlastung_paragraph_53a_energiestg: KWKAnlageEnergiesteuerentlastung_paragraph_53a_energiestg | null;
        bafa_anlagennummer: string | null;
        gesamtwirkungsgrad: number | null;
        nutzungsgrad: number | null;
        vollbenutzungsstunden: {
          year: number;
          hours: number | null;
        }[];
      } | null);
    StromErzeugungsEinheit: {
      id: number;
      bruttoleistung: number;
      im_mastr_registriert: boolean;
      name_stromerzeugungseinheit: string;
      /** Format: date */
      datum_erstmalige_inbetriebnahme?: string | null;
      /** @enum {string|null} */
      einspeisungsart: StromErzeugungsEinheitEinspeisungsart;
      seriennummer: string | null;
      beschreibung?: string | null;
      einheit_mastr_nummer: string | null;
      eeg_anlage?:
        | components["schemas"]["EEGAnlageBiomasse"]
        | components["schemas"]["EEGAnlageGSGK"]
        | components["schemas"]["EEGAnlageSolar"]
        | components["schemas"]["EEGAnlageWind"]
        | components["schemas"]["EEGAnlageWasser"];
      kwk_anlage?: components["schemas"]["KWKAnlage"];
      tr_id?: string | null;
      sr_code?: string | null;
    };
    SEESolar: components["schemas"]["StromErzeugungsEinheit"] & {
      zugeordnete_wirkleistung_wechselrichter: number | null;
    };
    SEEWind: components["schemas"]["StromErzeugungsEinheit"] & {
      typenbezeichnung: string | null;
    };
    /** @enum {string|null} */
    TechnologieVerbrennnungsanlageEnum: TechnologieVerbrennnungsanlageEnum | null;
    SEEBiomasse: components["schemas"]["StromErzeugungsEinheit"] & {
      technologie: components["schemas"]["TechnologieVerbrennnungsanlageEnum"];
      /** @enum {string|null} */
      hauptbrennstoff: SEEBiomasseHauptbrennstoff | null;
    };
    /** @enum {string|null} */
    EnergieTraegerEnum: EnergieTraegerEnum | null;
    SEEGSGK: components["schemas"]["StromErzeugungsEinheit"] & {
      technologie: components["schemas"]["TechnologieVerbrennnungsanlageEnum"];
      energietraeger: components["schemas"]["EnergieTraegerEnum"];
    };
    SEEVerbrennung: components["schemas"]["StromErzeugungsEinheit"] & {
      technologie: components["schemas"]["TechnologieVerbrennnungsanlageEnum"];
      energietraeger: components["schemas"]["EnergieTraegerEnum"];
      /** @enum {string|null} */
      hauptbrennstoff: SEEVerbrennungHauptbrennstoff | null;
    };
    SEEWasser: components["schemas"]["StromErzeugungsEinheit"];
    /** @description Selected data of a generator for a list entry. */
    GeneratorListEntry: {
      id?: number;
      type?: components["schemas"]["GeneratorType"];
      name?: string;
      bruttoleistung?: number;
      site?: string;
    };
    AnlageStromStg: {
      id?: number;
      variant?: number;
      bezeichnung?: string | null;
      has_standortuebergreifende_verklammerung?: boolean | null;
      stfrei_paragraph_9_abs_1_nr_1_stromstg?: components["schemas"]["YesNoChoice"];
      /** Format: date */
      datum_erlaubnis_stfrei_paragraph_9_abs_1_nr_1_stromstg?: string | null;
      einzelerlaubnis_steuerfreie_entnahme_zur_stromerzeugung?: components["schemas"]["YesNoChoice"];
      erlaubnisnummer_steuerfreie_entnahme?: string | null;
      /** Format: date */
      datum_einzelerlaubnis_steuerfreie_entnahme_zur_stromerzeugung?:
        string | null;
      stromstg_paragraph_9_1_3a?: components["schemas"]["YesNoChoice"];
      zeitraum_stromstg_paragraph_9_1_3a?: components["schemas"]["DateRange"];
      stromstg_paragraph_9_1_3b?: components["schemas"]["YesNoChoice"];
      zeitraum_stromstg_paragraph_9_1_3b?: components["schemas"]["DateRange"];
      hauptzollamt_anlagennummer?: string | null;
      nummer_erlaubnis_betriebserklaerung?: string | null;
      /** Format: date */
      datum_erlaubnis_betriebserklaerung?: string | null;
      generators?: components["schemas"]["GeneratorListEntry"][];
      hidden_fields?: string[] | null;
    } | null;
    SketchElementResponse: {
      id: number;
      x_position: number;
      y_position: number;
      icon: string;
    };
    GeneratorEmsysInfo: {
      is_vollmacht_provided?: boolean | null;
      /** Format: date */
      date_emsys_onboarding_start?: string | null;
    };
    /**
     * @description The application intent for Mieterstromzuschlag.
     * @enum {string|null}
     */
    MieterstromzuschlagApplicationIntent: MieterstromzuschlagApplicationIntent | null;
    Mieterstromzuschlag: {
      generator_id: number;
      application_intent: components["schemas"]["MieterstromzuschlagApplicationIntent"];
      /** Format: date */
      application_date: string | null;
    } | null;
    /** @description All data of a generator combined in one object. */
    Generator: {
      id?: number;
      name?: string;
      type?: components["schemas"]["GeneratorType"];
      operation_periods?: components["schemas"]["OperationPeriod"][];
      connection?: number;
      installed_capacity?: number;
      market_premium_via_tendering?: components["schemas"]["YesNoChoice"];
      yearly_energy?: number;
      /** Format: date */
      commissioning?: string;
      /** Format: date */
      decommissioning?: string | null;
      feedin_tariff_deprecated?: number | null;
      feedin_tariff_non_pv?: number | null;
      applicable_value_pv?: number | null;
      own_consumption_subsidy?: number | null;
      registered_for_mieterstrom?: components["schemas"]["YesNoChoice"];
      kwkg_direct_delivery_subsidy?: number | null;
      initial_installed_capacity?: number | null;
      building_installed?: components["schemas"]["YesNoChoice"];
      residential_building_installed?: components["schemas"]["YesNoChoice"];
      direct_marketing_fee?: number | null;
      market_value_eeg?: number | null;
      eligible_for_non_building_installed_feedin_tariff?: components["schemas"]["YesNoChoice"];
      site_id?: number;
      einheit?:
        | components["schemas"]["SEESolar"]
        | components["schemas"]["SEEWind"]
        | components["schemas"]["SEEBiomasse"]
        | components["schemas"]["SEEGSGK"]
        | components["schemas"]["SEEVerbrennung"]
        | components["schemas"]["SEEWasser"];
      anlage_stromstg?: components["schemas"]["AnlageStromStg"];
      is_combined?: boolean;
      sketch_element?: components["schemas"]["SketchElementResponse"];
      pv_projector?: string | null;
      pv_projector_contact?: string | null;
      pv_projector_contact_phone?: string | null;
      pv_projector_contact_mail?: string | null;
      is_partial_feedin_site?: boolean;
      onboarding_done?: boolean;
      is_redispatch_import_active?: boolean;
      emsys?: components["schemas"]["GeneratorEmsysInfo"];
      eligible_for_mieterstromzuschlag?: boolean | null;
      mieterstromzuschlag?: components["schemas"]["Mieterstromzuschlag"];
    };
    /** @description Data of a generator in list requests (api/generators -> component_serializers.GeneratorSerializer) */
    GeneratorOverview: {
      id?: number;
      name?: string;
      type?: components["schemas"]["GeneratorType"];
      /** @description Human-readable label of the generator type */
      type_label?: string;
      /** @description ID of the current operator if it exists */
      person?: number | null;
      connection?: number;
      installed_capacity?: number;
      market_premium_via_tendering?: components["schemas"]["YesNoChoice"];
      yearly_energy?: number;
      /**
       * Format: date
       * @description DD.MM.YYYY
       */
      commissioning?: string;
      /**
       * Format: date
       * @description DD.MM.YYYY or None
       */
      decommissioning?: string | null;
      feedin_tariff_deprecated?: number | null;
      feedin_tariff_non_pv?: number | null;
      applicable_value_pv?: number | null;
      own_consumption_subsidy?: number | null;
      registered_for_mieterstrom?: components["schemas"]["YesNoChoice"];
      kwkg_direct_delivery_subsidy?: number | null;
      initial_installed_capacity?: number | null;
      building_installed?: components["schemas"]["YesNoChoice"];
      residential_building_installed?: components["schemas"]["YesNoChoice"];
      direct_marketing_fee?: number | null;
      market_value_eeg?: number | null;
      eligible_for_non_building_installed_feedin_tariff?: components["schemas"]["YesNoChoice"];
      site?: number;
      site_name?: string;
      /**
       * Format: url
       * @description e.g. "/api/seewind/1/"
       */
      einheit?: string;
      anlage_stromstg?: number | null;
      is_combined?: boolean;
      sketch_element?: components["schemas"]["SketchElementResponse"];
      pv_projector?: string | null;
      pv_projector_contact?: string | null;
      pv_projector_contact_phone?: string | null;
      pv_projector_contact_mail?: string | null;
      is_redispatch_import_active?: boolean;
      is_redispatch_import_active_for_operator?: boolean | null;
      tr_id?: string | null;
      is_vollmacht_provided?: boolean | null;
      /**
       * Format: date
       * @description Date when the generator started onboarding for emsys, in the format DD.MM.YYYY.
       */
      date_emsys_onboarding_start?: string | null;
      /**
       * Format: date
       * @description first date FOR which we have received data from emsys, in the format DD.MM.YYYY. If no data has been received None
       */
      date_of_first_emsys_data?: string | null;
    };
    /** @enum {string} */
    PressureStage: PressureStage;
    /** @enum {string} */
    GasQuality: GasQuality;
    /** @description All data of a gas connection */
    GasConnectionResponse: {
      id: number;
      name: string;
      pressure_stage: components["schemas"]["PressureStage"];
      gas_quality: components["schemas"]["GasQuality"];
      /** @description ID of the connecting party, if any */
      connecting_party: number | null;
      /** @description ID of the site to which the gas connection belongs */
      site: number;
    };
    /** @description Data for updating a gas connection */
    GasConnectionUpdateRequest: {
      id: number;
      name?: string;
      pressure_stage?: components["schemas"]["PressureStage"];
      gas_quality?: components["schemas"]["GasQuality"];
      /** @description ID of the connecting party, if any */
      connecting_party?: number | null;
      /** @description ID of the site to which the gas connection belongs */
      site?: number;
    };
    /** @description Data for creating a gas connection */
    GasConnectionCreateRequest: {
      name: string;
      pressure_stage: components["schemas"]["PressureStage"];
      gas_quality: components["schemas"]["GasQuality"];
      /** @description ID of the connecting party, if any */
      connecting_party?: number | null;
      /** @description ID of the site to which the gas connection belongs */
      site: number;
      sketch_element: components["schemas"]["SketchElement"];
    };
    /** @description Contact information for a single market role (Marktrolle) of a Marktakteur */
    MarktrolleContact: {
      marktrolle: string;
      kontaktdaten_marktrolle: string | null;
    };
    /** @description Contact information for a market participant (Marktakteur) */
    MarktakteurContact: {
      firmenname: string;
      mastr_nummer: string;
      strasse: string;
      hausnummer: string;
      adresszusatz: string | null;
      postleitzahl: string;
      ort: string;
      zustell_strasse: string | null;
      zustell_hausnummer: string | null;
      zustell_adresszusatz: string | null;
      zustell_postleitzahl: string | null;
      zustell_ort: string | null;
      email: string | null;
      telefon: string | null;
      fax: string | null;
      webseite: string | null;
      marktrollen: components["schemas"]["MarktrolleContact"][];
    };
    /**
     * @description The transmission system operators (Übertragungsnetzbetreiber)
     * @enum {string|null}
     */
    TransmissionSystemOperator: TransmissionSystemOperator | null;
    /**
     * @description Type of energy supply in site. Either partial (only pv supply) or full (pv and grid supply)
     * @enum {string|null}
     */
    SupplyType: SupplyType | null;
    /** @description All data of an electricity connection (Netzverknüpfungspunkt) */
    ConnectionResponse: {
      id: number;
      name: string;
      voltage: components["schemas"]["VoltageLevel"];
      grid_operator: number;
      grid_operator_name: string;
      /** @description Contact information of the grid operator's Marktakteur, if available */
      grid_operator_marktakteur:
        components["schemas"]["MarktakteurContact"] | null;
      transmission_system_operator: components["schemas"]["TransmissionSystemOperator"];
      /** @description Contact information of the transmission system operator's Marktakteur, if a transmission system operator is set */
      transmission_system_operator_marktakteur:
        components["schemas"]["MarktakteurContact"] | null;
      /** @description ID of the site to which the connection belongs */
      site: number;
      /** @description ID of the connecting party (Netzanschlussnehmer), if any */
      connecting_party: number | null;
      /** @description ID of the person holding the supply contract, if any */
      supply_contract_held_by: number | null;
      /** @description ID of the metering concept (Messkonzept), if any */
      metering_concept: number | null;
      supply_type: components["schemas"]["SupplyType"];
      ghost_node: {
        id: number;
        name: string;
        site: number;
      } | null;
    };
    /** @description Data for updating an electricity connection (Netzverknüpfungspunkt) */
    ConnectionUpdateRequest: {
      id: number;
      name?: string;
      voltage?: components["schemas"]["VoltageLevel"];
      grid_operator?: number;
      transmission_system_operator?: components["schemas"]["TransmissionSystemOperator"];
      /** @description ID of the connecting party (Netzanschlussnehmer), if any */
      connecting_party?: number | null;
      /** @description ID of the person holding the supply contract, if any */
      supply_contract_held_by?: number | null;
      supply_type?: components["schemas"]["SupplyType"];
      /** @description ID of the metering concept (Messkonzept), if any */
      metering_concept?: number | null;
    };
    /** @description Data for creating an electricity connection (Netzverknüpfungspunkt) */
    ConnectionCreateRequest: {
      name: string;
      voltage: components["schemas"]["VoltageLevel"];
      grid_operator: number;
      transmission_system_operator?: components["schemas"]["TransmissionSystemOperator"];
      /** @description ID of the connecting party (Netzanschlussnehmer), if any */
      connecting_party?: number | null;
      /** @description ID of the person holding the supply contract, if any */
      supply_contract_held_by?: number | null;
      supply_type?: components["schemas"]["SupplyType"];
      /** @description ID of the metering concept (Messkonzept), if any */
      metering_concept?: number | null;
      /** @description ID of the site to which the connection belongs */
      site: number;
      sketch_element: components["schemas"]["SketchElement"];
    };
    /**
     * @description The type of a consumer (Verbrauchertyp)
     * @enum {string}
     */
    ConsumerComponentType: ConsumerComponentType;
    /**
     * @description Whether the consumption is for operational purposes (betriebliche Zwecke)
     * @enum {string|null}
     */
    OperationalPurpose: OperationalPurpose | null;
    /**
     * @description Eligibility for tax relief for particular processes (§ 9a StromStG)
     * @enum {string|null}
     */
    TaxReliefProcesses: TaxReliefProcesses | null;
    /** @description All data of a consumer (Verbraucher) */
    ConsumerResponse: {
      id: number;
      name: string;
      type: components["schemas"]["ConsumerComponentType"];
      /** @description Human-readable label of the consumer type */
      type_label: string;
      /** @description ID of the connection (Netzverknüpfungspunkt) the consumer belongs to */
      connection: number;
      /** @description ID of the person (Unternehmen) operating the consumer, if any */
      person: number | null;
      /** @description Electricity price in ct/kWh */
      electricity_price: number | null;
      /** @description Yearly energy consumption in kWh */
      yearly_energy: number | null;
      operational_purpose: components["schemas"]["OperationalPurpose"];
      eligible_for_tax_relief_for_particular_processes: components["schemas"]["TaxReliefProcesses"];
      /** @description ID of the site to which the consumer belongs */
      site: number;
    };
    /** @description Data for updating a consumer (Verbraucher) */
    ConsumerUpdateRequest: {
      id: number;
      name?: string;
      type?: components["schemas"]["ConsumerComponentType"];
      /** @description ID of the connection (Netzverknüpfungspunkt) the consumer belongs to */
      connection?: number;
      /** @description ID of the person (Unternehmen) operating the consumer */
      person?: number;
      /** @description Electricity price in ct/kWh */
      electricity_price?: number | null;
      /** @description Yearly energy consumption in kWh */
      yearly_energy?: number | null;
      operational_purpose?: components["schemas"]["OperationalPurpose"];
      eligible_for_tax_relief_for_particular_processes?: components["schemas"]["TaxReliefProcesses"];
    };
    /** @description Data for creating a consumer (Verbraucher) */
    ConsumerCreateRequest: {
      name: string;
      type: components["schemas"]["ConsumerComponentType"];
      /** @description ID of the connection (Netzverknüpfungspunkt) the consumer belongs to */
      connection: number;
      /** @description ID of the person (Unternehmen) operating the consumer */
      person: number;
      /** @description Electricity price in ct/kWh */
      electricity_price?: number | null;
      /** @description Yearly energy consumption in kWh */
      yearly_energy?: number | null;
      operational_purpose?: components["schemas"]["OperationalPurpose"];
      eligible_for_tax_relief_for_particular_processes?: components["schemas"]["TaxReliefProcesses"];
      /** @description ID of the site to which the consumer belongs */
      site?: number;
      sketch_element: components["schemas"]["SketchElement"];
    };
    /** @description A metering concept (Messkonzept) */
    MeteringConceptResponse: {
      id: number;
      name: string;
      description: string | null;
    };
    /** @enum {string|null} */
    MixKind: MixKind | null;
    Delivery: {
      /** Format: uuid */
      id?: string;
      /** Format: uuid */
      contract?: string;
      site?: number;
      generators?: number[];
      /** @enum {string} */
      delivery_kind?: DeliveryDelivery_kind;
      /** @enum {string} */
      price_model?: DeliveryPrice_model;
      use_spot_market_prices?: boolean;
      electricity_tax?: boolean;
      losses_transfer?: boolean;
      /** Format: binary */
      identification_graphic?: string | null;
      mix_kind?: components["schemas"]["MixKind"];
      green_countries?: string | null;
      /** Format: float */
      nuclear_percentage?: number | null;
      /** Format: float */
      coal_percentage?: number | null;
      /** Format: float */
      gas_percentage?: number | null;
      /** Format: float */
      other_fossil_percentage?: number | null;
      /** Format: float */
      tenant_percentage?: number | null;
      /** Format: float */
      renewable_not_promoted_percentage?: number | null;
      /** Format: float */
      renewable_promoted_percentage?: number | null;
      year_mix?: number | null;
      /** Format: float */
      emission_co2?: number | null;
      /** Format: float */
      radioactive_waste?: number | null;
      /** @enum {string|null} */
      grid_usage_billing_model?: DeliveryGrid_usage_billing_model | null;
      automatically_determine_grid_fees?: boolean | null;
      working_prices?:
        | {
            id?: number;
            /** Format: float */
            value?: number;
            /** Format: date-time */
            first_date?: string | null;
            /** Format: date-time */
            last_date?: string | null;
          }[]
        | null;
      working_prices_prognosis?:
        | {
            id?: number;
            /** Format: float */
            value?: number;
            /** Format: date-time */
            first_date?: string | null;
            /** Format: date-time */
            last_date?: string | null;
          }[]
        | null;
      concession_fees?:
        | {
            id?: number;
            /** Format: float */
            value?: number;
            /** Format: date-time */
            first_date?: string | null;
            /** Format: date-time */
            last_date?: string | null;
          }[]
        | null;
      grid_usage_power_prices?:
        | {
            id?: number;
            /** Format: float */
            value?: number;
            /** Format: date-time */
            first_date?: string | null;
            /** Format: date-time */
            last_date?: string | null;
          }[]
        | null;
      spot_market_prices?:
        | {
            id?: number;
            formula?: string;
            /** Format: date-time */
            first_date?: string | null;
            /** Format: date-time */
            last_date?: string | null;
          }[]
        | null;
      minimum_purchase_quantity_applicable?: boolean | null;
      minimum_purchase_quantity?: number | null;
    };
    GridFees: {
      energy_price: number;
      power_price?: number;
    };
    NonFieldErrors: {
      non_field_errors: string[];
    } & {
      [key: string]: unknown;
    };
    PendingInvoice: {
      id: string;
      /** Format: uuid */
      contract: string;
      site: number;
      site_name: string;
      supplier: number;
      supplied: number;
      /** Format: date */
      billing_period_start: string;
      /** Format: date */
      billing_period_end: string;
      is_advance_invoice: boolean;
      is_correction_invoice: boolean;
    };
    MSBVollmachtUploadSuccess: {
      id: number;
      name: string;
      /** Format: date-time */
      creation_datetime: string;
      created_by: {
        id: number;
        name: string;
        image: string | null;
      } | null;
      /** Format: date-time */
      revoked: string | null;
    };
    /** @description A validation error with machine-readable code and human-readable message */
    ValidationErrorCodeMessage: {
      code: string;
      message: string;
      is_reason_for_rejection: boolean;
    };
    VermarkterVollmachtUploadSuccess: {
      todo_file: number | null;
      site: number;
      person: number;
      /** @enum {string} */
      status: VermarkterVollmachtUploadSuccessStatus;
      signature_result: {
        /** @enum {string} */
        status?: VermarkterVollmachtUploadSuccessSignature_resultStatus;
        dark_pixel_ratio?: number | null;
        errors?: components["schemas"]["ValidationErrorCodeMessage"][];
      };
      document_complete: {
        /** @enum {string} */
        status?: VermarkterVollmachtUploadSuccessDocument_completeStatus;
        page_count?: number | null;
        errors?: components["schemas"]["ValidationErrorCodeMessage"][];
      };
      extracted_person: {
        name?: string;
        street_and_nr?: string;
        postal_code_city?: string;
        abr_number?: string;
        person_id?: number;
        errors?: components["schemas"]["ValidationErrorCodeMessage"][];
      };
      extracted_generators: {
        tr_id?: string;
        generator_id?: number;
        errors?: components["schemas"]["ValidationErrorCodeMessage"][];
      }[];
      additional_errors: components["schemas"]["ValidationErrorCodeMessage"][];
    };
    VollmachtUploadError:
      | {
          person: string;
        }
      | {
          payload_missing: string;
        }
      | {
          non_field_errors: string[];
        };
    VermarkterVollmachtConfirmationSuccess: {
      todo_file_id: number;
      user_confirmed_extracted_data: boolean;
      todo_closed: boolean;
    };
    VermarkterVollmachtConfirmationError: {
      [key: string]: string | string[];
    };
    Payment: {
      year: number;
      month?: number | null;
      /** Format: float */
      pending_payments?: number | null;
      pending_payments_description?: string | null;
      /** Format: float */
      discount_payments?: number | null;
      discount_description?: string | null;
    };
    InstallmentConfiguration: {
      year: number;
      /** @enum {string} */
      calculation_base: InstallmentConfigurationCalculation_base;
      /** Format: decimal */
      user_requested_installment_in_euro: string | null;
      /** Format: decimal */
      estimated_installment_in_euro: string | null;
      /** Format: decimal */
      estimated_delivery_amount_in_kwh: string | null;
      /** Format: decimal */
      estimated_share_direct_delivery_in_percent: string | null;
      /** Format: decimal */
      installment_payments_made: string | null;
    };
    Price: {
      id?: number;
      /** Format: float */
      value: number;
      /** Format: date-time */
      first_date: string | null;
      /** Format: date-time */
      last_date: string | null;
    };
    Contract: {
      /** Format: uuid */
      id: string;
      /** Format: uuid */
      project: string;
      supplier: number;
      supplied: number;
      name: string;
      product_name: string;
      /** Format: date */
      begin: string;
      /** Format: date */
      end?: string | null;
      /** Format: date */
      minimum_term: string;
      automatic_extension: boolean;
      /** @enum {string|null} */
      extension_duration_unit?: ContractExtension_duration_unit | null;
      extension_duration_value?: number | null;
      /** @enum {string|null} */
      cancelation_deadline_unit?: ContractCancelation_deadline_unit | null;
      cancelation_deadline_value?: number | null;
      /** @enum {string|null} */
      cancelation_reference?: ContractCancelation_reference | null;
      /** @enum {string} */
      billing_method_and_period: ContractBilling_method_and_period;
      /** @default false */
      monthly_invoice_documents_for_advance_payment: boolean;
      /** @default false */
      previous_electricity_consumption: boolean;
      /** @enum {string} */
      payment_method: ContractPayment_method;
      /** @enum {string} */
      due_date_unit: ContractDue_date_unit;
      due_date_value: number;
      payments: components["schemas"]["Payment"][];
      mandate_reference?: string;
      /** @enum {string} */
      state?: ContractState;
      installment_configurations?: components["schemas"]["InstallmentConfiguration"][];
      add_base_price: boolean;
      /** @enum {string} */
      add_price_measuring_point: ContractAdd_price_measuring_point;
      /** @default false */
      allowance_send_invoice_via_mail: boolean;
      /** @default false */
      automatic_send_invoice_active: boolean;
      /** Format: float */
      deposit?: number | null;
      /** @default false */
      is_template: boolean;
      /** @default true */
      is_vat_included: boolean | null;
      /** @enum {string|null} */
      vat_exemption_reason?: ContractVat_exemption_reason | null;
      custom_vat_exemption_reason?: string | null;
      base_prices: components["schemas"]["Price"][];
      measuring_point_prices: components["schemas"]["Price"][];
      /** Format: uuid */
      creation_template?: string | null;
      creation_template_site?: number | null;
      /** Format: date */
      valid_until?: string | null;
      /**
       * Format: integer
       * @default 0
       */
      extension_count: number;
      /**
       * Format: integer
       * @default 0
       */
      invoice_count: number;
    };
    OperatorListItem: {
      id: number;
      name: string;
    };
    DataQualityMeloMaloListItem: {
      melo_malo_id: number;
      melo_malo_name: string;
      meter_id: number | null;
      meter_name: string | null;
      site_id: number;
      site_name: string;
      /** Format: uuid */
      project_id: string;
    };
    UserFacingErrorWithButton: components["schemas"]["NonFieldErrors"] & {
      /** @example /manager/projekte/d29dd14e-b3c0-4a34-b721-5e1d287d0264/liegenschaften/15926/erzeuger/88850/eeg-anlage/ */
      button_url?: string | null;
      /** @example Anzulegenden Wert eintragen */
      button_caption?: string | null;
    };
    EnergyRevenuesListItem: {
      /**
       * Format: date
       * @example 01.07.2023
       */
      readonly period_start: string;
      /** @description Percentage amount of available data (0 - 100) */
      readonly available_percent: number | null;
      /** @description A list of melo/malos that have missing data */
      missing_data_sources: components["schemas"]["DataQualityMeloMaloListItem"][];
      /** @description A list of user-facing errors */
      errors: components["schemas"]["UserFacingErrorWithButton"][];
      /** @description A list of user-facing warnings */
      warnings?: string[];
      /** @description Vermarktungsentgelt EUR */
      readonly vermarktung_fee: number | null;
      /** @description Erlös Vermarktung netto in EUR, ohne Marktprämie, ohne Entgelt */
      readonly vermarktung_net_revenue: number | null;
      /** @description Menge Vermarktung in kWh */
      readonly vermarktung_volume: number | null;
      /** @description Marktprämie in EUR */
      readonly market_premium_revenue: number | null;
      /**
       * @description EEG erfordert Jahresmarktwert, der noch nicht vorhanden ist - und durch einen Monatsmarktwert ersetzt wurde
       * @enum {string}
       */
      readonly market_premium_revenue_source: EnergyRevenuesListItemMarket_premium_revenue_source;
      /** @description Menge Marktprämie in kWh */
      readonly market_premium_volume: number | null;
      /** @description Vermarktung abzüglich Entgelt in EUR */
      readonly net_revenue_minus_fee: number | null;
      /** @description Menge entgangener Marktprämie wegen eingespeistem Strom mit negativen Strompreisen gemäß § 51 in EUR */
      readonly negative_price_revenue: number | null;
      /** @description Menge eingespeister Strom mit negativen Strompreisen gemäß § 51 in kWh */
      readonly negative_price_volume: number | null;
      /** @description Menge Ausfallarbeit Redispatch in kWh */
      readonly ausfallarbeit_redispatch: number | null;
      /** @description Menge Ausfallarbeit DVA in kWh */
      readonly ausfallarbeit_dva: number | null;
      /** @description Erlös durch Redispatch in EUR (ohne Förderungen, einfach Menge * Preis) */
      readonly revenue_redispatch: number | null;
      /** @description Erlös Aufwandsersatz Redispatch in EUR (Abrechnung Netzbetreiber) */
      readonly aufwandsersatz_redispatch: number | null;
      /** @description Menge Ausfallarbeit Förderung Redispatch in kWh */
      readonly ausfallarbeit_foerderung_redispatch: number | null;
      /** @description Erlös Ausfallarbeit Förderung Redispatch in EUR */
      readonly revenue_foerderung_redispatch: number | null;
      /** @description Erlös Ausfallarbeit DVA in EUR */
      readonly revenue_dva: number | null;
      /** @description Entgelt für Redispatch in EUR */
      readonly redispatch_entgelt: number | null;
      /** @description Entgelt für DVA in EUR */
      readonly dva_entgelt: number | null;
      /** @description Monatsmarktwert Solar in EUR/MWh */
      readonly monatsmarktwert_solar?: number | null;
      /** @description Monatsmarktwert Wind in EUR/MWh */
      readonly monatsmarktwert_wind?: number | null;
      /** @description Jahresmarktwert Solar in EUR/MWh */
      readonly jahresmarktwert_solar?: number | null;
      /** @description Jahresmarktwert Wind in EUR/MWh */
      readonly jahresmarktwert_wind?: number | null;
    };
    EnergyRevenuesListResponse: components["schemas"]["EnergyRevenuesListItem"][];
    EnergyRevenuesCellCheckState: {
      /** @description ID of the person for which the cell check state is recorded. */
      person_id: number;
      /** @example 01.06.2025 */
      period_start: string;
      /** @enum {string} */
      column: EnergyRevenuesCellCheckStateColumn;
      /**
       * @example inProgress
       * @enum {string}
       */
      state: EnergyRevenuesCellCheckStateState;
      /** @description Amount that was calculated by the system at time of check. */
      calculated_amount: number;
      /** @description Amount that user provided as comparison to the calculated value. */
      user_provided_amount?: number | null;
      label?: string | null;
      notes?: string | null;
      /**
       * Format: uuid
       * @description Unique identifier of the cell check state record.
       */
      id?: string;
      /** @description Timestamp when the state was last changed, formatted as "DD.MM.YYYY HH:MM:SS". */
      timestamp_of_state_change?: string | null;
      /** @description Name of the user who made the last state change. */
      author_of_state_change_name?: string | null;
    };
    EnergyRevenuesCellCheckStateResponse: components["schemas"]["EnergyRevenuesCellCheckState"] & {
      /** Format: uuid */
      readonly id: string;
      /** @example 24.06.2025 12:22:02 */
      readonly timestamp_of_state_change: string;
      readonly author_of_state_change_name: string;
    };
    /** @enum {string} */
    SiteLicense: SiteLicense;
    SiteCategoriesResponse: {
      readonly id: number;
      readonly name: string;
      readonly is_eigenerzeugung_plus: boolean;
      readonly is_full_feedin: boolean;
      readonly is_partial_feedin_site: boolean;
      readonly is_ppaaas: boolean;
      license: components["schemas"]["SiteLicense"] & unknown;
    };
    SiteCategoriesUpdateRequest: {
      id: number;
      is_eigenerzeugung_plus?: boolean;
      is_partial_feedin_site?: boolean;
      is_ppaaas?: boolean;
      license?: components["schemas"]["SiteLicense"];
    };
    SiteLicenseSummary: {
      value: components["schemas"]["SiteLicense"];
      count: number;
    };
    SiteCategoriesSummaryResponse: {
      readonly is_eigenerzeugung_plus: boolean;
      readonly is_full_feedin: boolean;
      readonly is_partial_feedin_site: boolean;
      readonly is_ppaaas: boolean;
      readonly license: components["schemas"]["SiteLicenseSummary"][];
    };
    SiteNotificationDetailBase: {
      id: number;
      name: string;
    };
    SiteNotificationDetail: components["schemas"]["SiteNotificationDetailBase"] & {
      url: string;
    };
    SiteNotification: {
      id: number;
      generators_full_feedin: components["schemas"]["SiteNotificationDetail"][];
      meters_conversion_factor: components["schemas"]["SiteNotificationDetail"][];
      tenant_outside_mieterstrom_model: components["schemas"]["SiteNotificationDetailBase"][];
    };
    /**
     * @description The status of the site setup assistant
     * @enum {string}
     */
    SiteSetupProcessStatus: SiteSetupProcessStatus;
    SiteSetupProcess: {
      /**
       * Format: uuid
       * @description The UUID of the setup process
       */
      readonly id: string;
      /** @description The name of the site */
      readonly name: string;
      status: components["schemas"]["SiteSetupProcessStatus"];
      /**
       * @description The current step of the site setup process; defaults to "name_and_pv_plants" if setup didn't start yet
       * @enum {string|null}
       */
      step: SiteSetupProcessStep | null;
    };
    /**
     * @description How the meter is measured, choices are:
     *       - single: A single data point for a fixed period of time, e.g. 15 minutes.
     *       - arbitrary_cumulative: Arbitrary meter readings, incrementing over time.
     *       - no_meter: No meter is present. This means that the parent object is not measured by a meter.
     * @enum {string|null}
     */
    MeterMeasurementType: MeterMeasurementType | null;
    /**
     * @description Defines which direction the meter is measuring.
     * @enum {string|null}
     */
    MeteringDirection: MeteringDirection | null;
    /** @description The metering point of a pv plant, consumer or grid connection */
    NullableMeter: {
      /** @description The name of the meter. Purely for identification purposes. */
      name: string;
      measurement_type?: components["schemas"]["MeterMeasurementType"];
      metering_direction?: components["schemas"]["MeteringDirection"];
      /** @description The id of a metering service provider.  The metering service provider is responsible for delivering metering data for this specific meter. It may be null if the metering service provider is not known or not needed. */
      metering_service_provider?: number | null;
      /** @description ID of a Mess- or Marktlokation which has energy data representing feedin or generation.  A Marklokation is an accounting and billing construct where energy data is either generated or consumed. */
      location_feedin?: string | null;
      /** @description ID of a Mess- or Marktlokation which has energy data representing feedout or consumption. */
      location_feedout?: string | null;
      /** @description A generic number uniquely identifying the meter. There is no strict format for this number. This is typical for meters in private households that measure electricity consumption. */
      number?: string | null;
      /** @description Whether the meter is calibrated or not. */
      is_calibrated?: boolean | null;
    } | null;
    /** @description A person, usually company, that operator a pv plant. */
    Operator: {
      /** @description A MaStR number for a Anlagenbetreiber (ABR) in the Marktstammdatenregister (MaStR) to uniquely identify  the operator. A MaStR number for a Anlagenbetreiber (ABR) consists of the prefix “ABR,” a version number  (starting with “9”), ten random digits, and a check digit calculated using the EAN method for validation  (e.g., ABR 9 1234567890 8, ABR 9 9876543210 5). For more information see: https://www.marktstammdatenregister.de/MaStRHilfe/files/regHilfen/MaStR-Nummernkonzept.pdf */
      abr_number?: string | null;
      /** @description Whether this operator can be imported from MaStR or not.  Private persons can have a MaStR number but cannot be imported from MaStR because their data is not public. */
      can_be_imported_from_mastr?: boolean | null;
      /** @description The name of the operator. Can be empty if the ABR number is sufficient for identification. */
      name?: string | null;
    } | null;
    /** @description A pv plant on the site. Has a mandatory SEE number and optional meter and operator data. Meter and operator data must be added later in the setup process. */
    PVPlant: {
      /** @description The name of a PV plant if no MaStR number is provided */
      name?: string | null;
      /** @description A MaStR number for a Stromerzeugungseinheit (SEE) in the Marktstammdatenregister (MaStR) to uniquely identify  the PV plant. A MaStR number for a Stromerzeugungseinheit (SEE) consists of the prefix “SEE,” a version number  (starting with “9”), ten random digits, and a check digit calculated using the EAN method for validation  (e.g., SEE 9 1234567890 8, SEE 9 9876543210 5). For more information see: https://www.marktstammdatenregister.de/MaStRHilfe/files/regHilfen/MaStR-Nummernkonzept.pdf */
      see_number?: string | null;
      meter?: components["schemas"]["NullableMeter"];
      operator?: components["schemas"]["Operator"];
      /** Format: decimal */
      bruttoleistung?: string | null;
      /**
       * Format: date
       * @example 2024-09-24
       */
      commissioning?: string | null;
    };
    /** @description The address of any entity */
    AddressInfo: {
      /** @description The street and house number, e.g. Friedrichstraße 50 */
      address?: string | null;
      /** @description The postal code, e.g. 10115 */
      zip?: string | null;
      /** @description The name of the city, e.g. Berlin */
      city?: string | null;
    };
    /**
     * @description The type of a consumer
     * @enum {string|null}
     */
    ConsumerType: ConsumerType | null;
    /** @description The metering point of a consumer. The only difference is that a meter is required for a consumer. */
    Meter: {
      /** @description The name of the meter. Purely for identification purposes. */
      name: string;
      measurement_type?: components["schemas"]["MeterMeasurementType"];
      metering_direction?: components["schemas"]["MeteringDirection"];
      /** @description The id of a metering service provider.  The metering service provider is responsible for delivering metering data for this specific meter. It may be null if the metering service provider is not known or not needed. */
      metering_service_provider?: number | null;
      /** @description ID of a Mess- or Marktlokation which has energy data representing feedin or generation.  A Marklokation is an accounting and billing construct where energy data is either generated or consumed. */
      location_feedin?: string | null;
      /** @description ID of a Mess- or Marktlokation which has energy data representing feedout or consumption. */
      location_feedout?: string | null;
      /** @description A generic number uniquely identifying the meter. There is no strict format for this number. This is typical for meters in private households that measure electricity consumption. */
      number?: string | null;
      /** @description Whether the meter is calibrated or not. */
      is_calibrated?: boolean | null;
    };
    /** @description A tenant of a consumer */
    Tenant: {
      name?: string | null;
      is_participating_in_mieterstrom?: boolean | null;
      address: components["schemas"]["AddressInfo"];
      billing_address_is_same_as_address?: boolean | null;
    };
    /** @description A consumer on the site. This is a location where energy is consumed, e.g. a house or a factory. */
    Consumer: {
      name: string | null;
      consumer_type?: components["schemas"]["ConsumerType"];
      meter: components["schemas"]["Meter"];
      tenant: components["schemas"]["Tenant"];
    };
    /** @description A battery storage of the site. It can be measured by its own meter or unmeasured. In the latter case, the meter property should is to null. */
    BatteryStorage: {
      /** @description The name of the battery storage. Can be set by the user purely for identification purposes */
      name: string;
      meter?: components["schemas"]["NullableMeter"];
    } | null;
    /** @description This object is used to store the data of the site setup process for a Mieterstrom site.  The data is sent back and forth between the frontend during the setup process. I will be validated and stored in the database. After the final step, the data is then used to create the site object and populate the site with generator, consumer  and other objects. */
    SiteSetupProcessData: {
      /**
       * @description The current step of the setup process
       * @enum {string}
       */
      step?: SiteSetupProcessDataStep;
      /** @description The site object which is being set up */
      site?: {
        /** @description The name of the site. Can be set by the user purely for identification purposes */
        name: string;
        /** @description The PV plants of the site */
        pv_plants?: components["schemas"]["PVPlant"][] | null;
        connection_voltage_level?: components["schemas"]["VoltageLevel"];
        supply_type?: components["schemas"]["SupplyType"];
        address?: components["schemas"]["AddressInfo"];
        /** @description Whether the site address was manually set or overridden by the user during the setup process */
        address_manually_overridden?: boolean;
        connection_meter?: components["schemas"]["NullableMeter"];
        /** @description All the locations where energy is consumed, e.g. households, businesses, etc. */
        consumers?: components["schemas"]["Consumer"][];
        battery_storage?: components["schemas"]["BatteryStorage"];
        /** @description The id of the grid operator.  The grid operator is responsible for delivering energy to the site. */
        grid_operator?: number | null;
      };
      default_pv_plants_measurement_type?: components["schemas"]["MeterMeasurementType"];
      /**
       * @description The origin of the energy data of the connection meter. Whether the energy data is gathered from a metering location, a market location, or is unknown by the  user during the setup process. The in first two cases, the user must provide the corresponding ID.
       * @enum {string|null}
       */
      connection_meter_energy_data_origin?: SiteSetupProcessDataConnection_meter_energy_data_origin | null;
      /** @description Whether the voltage level of the connection was determined automatically by the system or needs to be set  manually by the user. In most cases, the voltage level can be determined from the Marktstammdatenregister. */
      voltage_level_determined_automatically?: boolean | null;
      /** @description Whether the responsible grid operator was determined automatically by the system or needs to be set  manually by the user. In most cases, it can be determined from the Marktstammdatenregister. */
      grid_operator_determined_automatically?: boolean | null;
      /**
       * @description The default amount of consumers in the site.  Together with other properties this property is used to prepopulate the consumer list:
       *       - default_consumer_type
       *       - default_consumer_measurement_type
       *       - all_tenant_addresses_are_same_as_site_address
       *       - all_tenants_participating_in_mieterstrom
       */
      consumer_amount?: number | null;
      default_consumer_type?: components["schemas"]["ConsumerType"];
      default_consumer_measurement_type?: components["schemas"]["MeterMeasurementType"];
      /** @description Whether all tenant addresses are the same as the site address. The tenant addresses can be set manually later, but this flag is used to prepopulate the tenant list with the site address. */
      all_tenant_addresses_are_same_as_site_address?: boolean | null;
      /** @description Whether all tenants are participating in the Mieterstrom model.  This flag is used to prepopulate the tenant properties. */
      all_tenants_participating_in_mieterstrom?: boolean | null;
      /** @description Whether a battery storage object should be created in this site.  The operator is the same as the operator of the pv plants. */
      site_has_battery_storage?: boolean | null;
      /** @description Whether the battery storage is measured by its own meter. If true, a meter object for the battery storage will be created. */
      is_battery_storage_measured_separately?: boolean | null;
      /** @description Whether any pv meets the criteria to apply for Mieterstromzuschlag. Mieterstromzuschlag is a surcharge for electricity delivered from a pv plant to tenants on site. */
      any_pv_plant_eligible_for_mieterstromzuschlag?: boolean | null;
      /**
       * @description The application intent for Mieterstromzuschlag. Whether the user already applied, wants to apply or does not want to apply.
       * @enum {string|null}
       */
      mieterstromzuschlag_application_intent?: SiteSetupProcessDataMieterstromzuschlag_application_intent | null;
      /**
       * Format: date
       * @example 2024-09-24
       */
      mieterstromzuschlag_application_date?: string | null;
    };
    /** @description A list of validation error codes */
    ValidationErrorCode: ValidationErrorCode[];
    /** @enum {string} */
    StartPageTileSize: StartPageTileSize;
    StartPageTile: {
      /** @enum {string} */
      name: StartPageTileName;
      /** @enum {string} */
      display_mode: StartPageTileDisplay_mode;
      size: components["schemas"]["StartPageTileSize"];
    };
    StartPageSite: {
      id: number;
      name: string;
      /** Format: uuid */
      project_id: string;
      project_name: string;
    };
    PaginatedList: {
      count?: number;
      /** Format: uri */
      next?: string | null;
      /** Format: uri */
      previous?: string | null;
      results?: Record<string, never>[];
    };
    RegulatoryTodo: {
      id?: number;
      name?: string;
      /** Format: date-time */
      created_at?: string;
      /** Format: date */
      due_date?: string;
      person_name?: string | null;
      /** Format: uuid */
      project_id?: string;
      project_name?: string;
      tag?: string;
    };
    PaginatedRegulatoryTodoList: components["schemas"]["PaginatedList"] & {
      results?: components["schemas"]["RegulatoryTodo"][];
    };
    /** @enum {string} */
    OnboardingTodoStatus: OnboardingTodoStatus;
    OnboardingTodo: {
      id?: number;
      site_id?: number;
      site_name?: string;
      todo_name?: string;
      todo_status?: components["schemas"]["OnboardingTodoStatus"];
      /** Format: uuid */
      project_id?: string;
      project_name?: string;
    };
    PaginatedOnboardingTodoList: components["schemas"]["PaginatedList"] & {
      results?: components["schemas"]["OnboardingTodo"][];
    };
    DeliveredElectricity: {
      /** @description Value in kWh */
      sum_direct?: number;
      /** @description Value in kWh */
      sum_forwarded?: number;
    };
    Co2Savings: {
      sum?: number;
    };
    Paragraph6EEGParticipation: {
      /** Format: float */
      sum?: string;
      /** Format: float */
      paid?: string;
    };
    NumberOfInvoices: {
      created?: number;
      sent?: number;
    };
    SiteSetupProcessTileData: {
      /** Format: uuid */
      id: string;
      site_name: string;
      status: components["schemas"]["SiteSetupProcessStatus"];
      /** Format: uuid */
      project_id: string;
      project_name: string;
    };
    SiteQuickSearchResult: {
      /** @description Site ID */
      id: number;
      /** @description Site name */
      name: string;
      /** @description Variant ID */
      variant: number;
      /** @description Project ID */
      project_id: string;
    };
    ContractQuickSearchResult: {
      /** @description Contract ID */
      id: number;
      /** @description Contract name */
      name: string;
    };
    PersonQuickSearchResult: {
      /** @description Person ID */
      id: number;
      /** @description Person name */
      name: string;
      /** @description Project ID */
      project_id: string;
      /** @description MaStR-Nummer des Marktakteurs */
      mastr_nummer_marktakteur: string | null;
    };
    GeneratorQuickSearchResult: {
      /** @description Generator ID */
      id: number;
      /** @description Generator name */
      name: string;
      /** @description Site ID */
      site_id: number;
      /** @description Project ID */
      project_id: string;
      /** @description TR-ID (technische Ressource) */
      tr_id: string | null;
      /** @description MaStR-Nummer der Einheit */
      mastr_nummer: string | null;
    };
    QuickSearchResponse: {
      sites: components["schemas"]["SiteQuickSearchResult"][];
      direktvermarktungsvertraege: components["schemas"]["ContractQuickSearchResult"][];
      persons: components["schemas"]["PersonQuickSearchResult"][];
      generators: components["schemas"]["GeneratorQuickSearchResult"][];
    };
    AusfallarbeitUploadResponse: {
      success: boolean;
      detail: string;
    };
    /** @enum {string} */
    Abregler: Abregler;
    AusfallarbeitTimeSeries: {
      generator_id: number;
      abregler: components["schemas"]["Abregler"];
      /** @enum {string|null} */
      abrechnungsmodell?: AusfallarbeitTimeSeriesAbrechnungsmodell | null;
      /** @description UTC timestamps in ISO format. */
      index: string[];
      /** @description Ausfallarbeit values in kWh. */
      values: (number | null)[];
    };
    /** @description A single human readable, user facing error message */
    DetailMessage: {
      /**
       * @description A human readable error message
       * @example Dem Erzeuger fehlen die für das Erlösmonitoring erforderlichen Felder: TR-ID, installierte Leistung.
       */
      detail: string;
    };
    Paragraph6EEGCreditResponse: {
      /** Format: uuid */
      id: string;
      /** Format: date */
      billing_period_start: string;
      /** Format: date */
      billing_period_end: string;
      community_name: string;
      /** Format: date-time */
      creation_date?: string | null;
      /** Format: date */
      date_of_payment: string;
      document_name: string;
      /** @enum {unknown} */
      state: Paragraph6EEGCreditResponseState;
      supplier: string;
      todo_id?: number | null;
      /** Format: date */
      todo_due_date?: string | null;
      grid_operator?: string | null;
      /** @enum {string} */
      readonly todo_alert_state?: Paragraph6EEGCreditResponseTodo_alert_state;
      is_payment_information: boolean;
    };
    Paragraph6EEGCreditDataResponse: {
      /** Format: date-time */
      created_at: string;
      /** Format: uuid */
      credit_id: string;
      community_name: string;
      supplier_name: string;
      /** Format: date */
      billing_period_start: string;
      /** Format: date */
      billing_period_end: string;
      /** Format: float */
      energy_data_completeness_percentage: number;
      /** Format: decimal */
      kwh_total: string;
      /** Format: decimal */
      kwh_einspeisung: string;
      /** Format: decimal */
      kwh_einspeisung_erstattungsfaehig: string | null;
      /** Format: decimal */
      kwh_einspeisung_nicht_erstattungsfaehig: string | null;
      /** Format: decimal */
      kwh_fiktiv: string;
      /** Format: decimal */
      eur_total: string;
      /** Format: decimal */
      eur_einspeisung: string;
      /** Format: decimal */
      eur_einspeisung_erstattungsfaehig: string | null;
      /** Format: decimal */
      eur_einspeisung_nicht_erstattungsfaehig: string | null;
      /** Format: decimal */
      eur_fiktiv: string;
      gemeinde_anteil_erzeuger_data: {
        generator_name: string;
        /** Format: decimal */
        community_share: string;
        /** Format: decimal */
        kwh_einspeisung: string;
        /** Format: decimal */
        kwh_einspeisung_erstattungsfaehig: string;
        /** Format: decimal */
        kwh_fiktiv: string;
        /** Format: decimal */
        eur_einspeisung: string;
        /** Format: decimal */
        eur_einspeisung_erstattungsfaehig: string;
        /** Format: decimal */
        eur_fiktiv: string;
        p51_rule: string;
        calculated_generation_shares: {
          /** Format: date */
          period_start: string;
          /** Format: date */
          period_end: string;
          /** Format: decimal */
          share: string;
        }[];
      }[];
    };
    /** @enum {string} */
    PaymentIntervallAndBillingMethod: PaymentIntervallAndBillingMethod;
    /** @enum {string} */
    PaymentMethod: PaymentMethod;
    /** @enum {string} */
    DirectMarketingType: DirectMarketingType;
    GemeindeAnteilErzeuger: {
      /** Format: uuid */
      readonly contract: string;
      /** Format: float */
      community_share: string;
      direct_marketing_type?: components["schemas"]["DirectMarketingType"];
      generator: number;
      readonly generator_display_name?: string;
      readonly site?: number;
      /** Format: float */
      readonly weighting?: string | null;
      readonly metering_or_market_location?: number;
      readonly metering_or_market_location_display_name?: string | null;
      readonly anlagenschluessel_eeg?: string;
    };
    Paragraph6EEGContract: {
      /** Format: uuid */
      id: string;
      variant: number;
      supplier: number;
      name: string;
      /** Format: date */
      signing_date: string;
      /** Format: date */
      begin: string;
      /** Format: date */
      end: string | null;
      /** Format: date */
      minimum_term: string | null;
      billing_method_and_period: components["schemas"]["PaymentIntervallAndBillingMethod"];
      payment_method: components["schemas"]["PaymentMethod"];
      due_date_unit: string | null;
      due_date_value: number | null;
      /** Format: date */
      billing_period_start: string;
      split_billing_period_at_year_boundary: boolean;
      /** Format: float */
      beteiligung: string;
      /** Format: float */
      beteiligung_nicht_erstattungsfaehig: string | null;
      /** Format: float */
      beteiligung_fiktive_strommengen: string | null;
      community_name: string;
      community_name_extra: string | null;
      community_address: string;
      community_address_extra: string | null;
      community_zip: string;
      community_city: string;
      community_email: string | null;
      community_kontoinhaber: string | null;
      community_iban: string | null;
      community_bic: string | null;
      community_phone?: string | null;
      sepa_remittance_information?: string | null;
      gemeinde_anteile_erzeuger: components["schemas"]["GemeindeAnteilErzeuger"][];
      formula_beteiligung?: string | null;
      formula_beteiligung_text?: string | null;
      formula_beteiligung_nicht_erstattungsfaehig?: string | null;
      formula_beteiligung_nicht_erstattungsfaehig_text?: string | null;
      is_template: boolean;
      readonly use_payment_information: boolean;
      notes?: string | null;
    };
    Paragraph6UnassignedGeneratorsResponse: {
      generator: number;
      readonly generator_display_name: string;
      readonly generator_type: components["schemas"]["GeneratorType"];
      readonly site: number;
      readonly name: string;
      /** Format: float */
      readonly weighting?: string | null;
      /**
       * Format: float
       * @description Value in ct/kWh
       */
      anzulegender_wert?: string | null;
      foerderregime?: components["schemas"]["FoerderRegime"];
      readonly anlagenschluessel_eeg?: string;
      readonly installed_capacity?: number | null;
    };
    Paragraph6EEGCreditNumberRange: {
      supplier: number;
      /** @example {JJJJ}-{Nummer} */
      format: string;
      /** @example 001 */
      counter_start_value: string;
      /** @enum {string|null} */
      counter_reset_interval?: Paragraph6EEGCreditNumberRangeCounter_reset_interval;
      /** Format: date */
      valid_from: string;
    };
    Paragraph6EEGCreditNumberRangeResponse: components["schemas"]["Paragraph6EEGCreditNumberRange"] & {
      /** Format: uuid */
      readonly id: string;
      /** Format: date */
      readonly created: string;
      readonly is_in_use?: boolean;
    };
    /** @enum {string|null} */
    DirektvermarktungContractRemunerationType: DirektvermarktungContractRemunerationType | null;
    /** @enum {string} */
    DirektvermarktungContractRedispatchStatusDuldungsfall: DirektvermarktungContractRedispatchStatusDuldungsfall;
    /** @enum {string} */
    DirektvermarktungContractRedispatchBilanzierungsmodell: DirektvermarktungContractRedispatchBilanzierungsmodell;
    PPAFixedPriceComponent: {
      /** Format: date */
      start_date: string;
      /** Format: date */
      end_date: string;
      /** Format: float */
      revenue: number | null;
    };
    DirektvermarktungContract: {
      name: string;
      operator_id: number;
      direktvermarkter_id: number | null;
      contract_remuneration_type: components["schemas"]["DirektvermarktungContractRemunerationType"];
      /** Format: date */
      first_date: string;
      /** Format: date */
      last_date: string;
      formula_entgelt?: string;
      formula_verguetung?: string;
      redispatch_status_duldungsfall: components["schemas"]["DirektvermarktungContractRedispatchStatusDuldungsfall"];
      redispatch_bilanzierungsmodell: components["schemas"]["DirektvermarktungContractRedispatchBilanzierungsmodell"];
      redispatch_tr_abrechnungsmodell: components["schemas"]["DirektvermarktungContractTrAbrechnungsmodell"];
      redispatch_has_dedicated_entgelt: boolean;
      formula_redispatch_entgelt?: string;
      redispatch_has_dedicated_verguetung: boolean;
      formula_redispatch_verguetung?: string;
      abregelung_tr_abrechnungsmodell: components["schemas"]["DirektvermarktungContractTrAbrechnungsmodell"];
      abregelung_has_dedicated_entgelt: boolean;
      formula_abregelung_entgelt?: string;
      abregelung_has_dedicated_verguetung: boolean;
      formula_abregelung_verguetung?: string;
      generation_shares?: components["schemas"]["DirektvermarktungGeneratorShare"][];
      ppa_fixed_price_components?: components["schemas"]["PPAFixedPriceComponent"][];
    };
    DirektvermarktungContractResponse: {
      name: string;
      operator_id: number;
      direktvermarkter_id: number | null;
      contract_remuneration_type: components["schemas"]["DirektvermarktungContractRemunerationType"];
      /** Format: date */
      first_date: string;
      /** Format: date */
      last_date: string;
      formula_entgelt?: string;
      formula_verguetung?: string;
      redispatch_status_duldungsfall?: components["schemas"]["DirektvermarktungContractRedispatchStatusDuldungsfall"];
      redispatch_bilanzierungsmodell?: components["schemas"]["DirektvermarktungContractRedispatchBilanzierungsmodell"];
      redispatch_tr_abrechnungsmodell?: components["schemas"]["DirektvermarktungContractTrAbrechnungsmodell"];
      redispatch_has_dedicated_entgelt: boolean;
      formula_redispatch_entgelt?: string;
      redispatch_has_dedicated_verguetung: boolean;
      formula_redispatch_verguetung?: string;
      abregelung_tr_abrechnungsmodell?: components["schemas"]["DirektvermarktungContractTrAbrechnungsmodell"];
      abregelung_has_dedicated_entgelt: boolean;
      formula_abregelung_entgelt?: string;
      abregelung_has_dedicated_verguetung: boolean;
      formula_abregelung_verguetung?: string;
      /** Format: uuid */
      readonly id: string;
      readonly inferred_veraeusserungsform?: components["schemas"]["Veraeusserungsform"];
      readonly generation_shares: components["schemas"]["DirektvermarktungGeneratorShareResponse"][];
      readonly ppa_fixed_price_components?: components["schemas"]["PPAFixedPriceComponent"][];
    };
    DirektvermarktungContractExtension: {
      /** Format: date */
      last_date: string;
    };
    /** @description Dynamic metering data based on ID and metering direction */
    GapsInMeteringData: {
      /**
       * Format: string
       * @example machine_account
       */
      expected_origin: string;
    } & {
      [key: string]: {
        gaps: string[][];
        /** @enum {string} */
        measurand: GapsInMeteringDataMeasurand;
      };
    };
    DataImportRequestSupportRequest: {
      support_comment: string | null;
    };
    EnergyDataFile: {
      /** Format: uuid */
      readonly id: string;
      name: string;
      data_file: string;
    } | null;
    /**
     * @description Processing status of a data import request
     * @enum {string}
     */
    DataImportRequestStatus: DataImportRequestStatus;
    /**
     * @description Kind of data contained in a data import request
     * @enum {string}
     */
    DataImportRequestType: DataImportRequestType;
    /** @description Maps each field that failed at least one validation to that field's list of validation details. */
    ValidatedObject: {
      [key: string]: components["schemas"]["ValidationErrorMessage"];
    };
    NotFound: {
      detail?: string;
    };
    ActiveUser: {
      id: number;
      name: string;
      email: string;
      company: string | null;
    };
    TodoLabel: {
      id?: number;
      label?: string;
    };
    TodosCanGenerateDocuments: {
      can_generate_documents_automatically?: boolean;
      can_generate_proforma_documents?: boolean;
      is_form_admin_user?: boolean;
      warnings?: string[];
      document_generation_blocker?: {
        missing_data?: {
          object_name?: string;
          object_id?: number;
          site_id?: number;
          parameter?: string;
        };
        message?: string;
      };
      todo_identifier?: string;
    };
    TodosUpdateUserDecisions: {
      todos?: {
        id?: number;
        /** @enum {string} */
        user_decision?: TodosUpdateUserDecisionsTodosUser_decision;
      }[];
    };
    RegulatoryDutyEvent: {
      title: string;
      rrule: string;
    };
    RegulatoryDuty: {
      id: number;
      name: string;
      description: string;
      obligor: string;
      /** @enum {string} */
      category: RegulatoryDutyCategory;
      obligee: string;
      fulfillment_process: string;
      deadline: string;
      recurring: boolean;
      legal_basis: string;
      additional_information: string;
      events: components["schemas"]["RegulatoryDutyEvent"][];
      slug?: string;
    };
    TodoDetail: {
      id: number;
      label: string;
      description: string | null;
      variant: number;
      regulatory_duty:
        | (Record<string, never> | null)
        | components["schemas"]["RegulatoryDuty"];
      person: string | null;
      /** Format: date-time */
      due_date: string | null;
      overdue: boolean;
      responsible: number | null;
      status: string;
      /** @enum {string} */
      user_decision: TodoDetailUser_decision;
      system_created: boolean;
      /** @enum {string|null} */
      system_decision: TodoDetailSystem_decision;
      todo_logs: {
        /** Format: date-time */
        creation_datetime?: string;
        user?: string;
        description?: string;
      }[];
      todo_files: {
        id?: number;
        name?: string;
        /** Format: date-time */
        creation_datetime?: string;
        created_by?: components["schemas"]["ExtendedUser"];
        revoked?: string | null;
      }[];
      fulfill_for: string | null;
      /** @enum {string} */
      category: TodoDetailCategory;
      /** @enum {string} */
      cluster: TodoDetailCluster;
      /** @enum {string} */
      priority: TodoDetailPriority;
      project: string;
      document_provided: boolean;
      /** @enum {string} */
      group: TodoDetailGroup;
      recurring: boolean;
    };
    TodoCalendarIntegration: {
      id: number;
      variant: number;
      user: number;
      /** Format: uri */
      calendar_url: string;
    };
    TodoCalendarIntegrationCreate: {
      variant: number;
    };
    TodoNote: {
      id: number;
      /** @description Creation time formatted as "DD.MM.YYYY HH:MM:SS" */
      created: string;
      note: string;
      todo: number;
      internal: boolean;
      author: {
        id: number;
        name: string;
      };
    };
    TodoNoteCreate: {
      note: string;
      todo: number;
      internal?: boolean;
      /** @description Staff only */
      as_system_user?: boolean;
    };
    TodoNoteUpdate: {
      note: string;
      internal: boolean;
    };
    Download: {
      /** Format: byte */
      encoded_file_data?: string;
      file_name?: string;
      warnings?: string[];
    };
    VariantDetail: {
      id?: number;
      name?: string;
      bundle_consumers?: boolean;
      hidden?: boolean;
      disregard_eeg_levy?: boolean;
      paragraph_6_payment_information_instead_of_credit?: boolean;
    };
    SiteResponse: {
      readonly id: number;
      /** Format: uuid */
      readonly global_id: string;
      name: string;
      address: string;
      address_extra: string;
      /** Format: integer */
      zip: string;
      city: string;
      readonly variant: number;
      no_scada: boolean;
      invoicing_active: boolean;
      metering_concept_v2_active: boolean;
      go_active: boolean;
      premium_todos_active: boolean;
      readonly is_mieterstrom_site: boolean;
    };
    SiteCreationRequest: {
      name: string;
      address: string;
      address_extra: string;
      /** Format: integer */
      zip: string;
      city: string;
      readonly variant: number;
      no_scada?: boolean;
      invoicing_active?: boolean;
      metering_concept_v2_active?: boolean;
      go_active?: boolean;
      premium_todos_active?: boolean;
      readonly is_mieterstrom_site?: boolean;
    };
    SiteUpdateRequest: {
      name?: string;
      address?: string;
      address_extra?: string;
      /** Format: integer */
      zip?: string;
      city?: string;
      readonly variant?: number;
      no_scada?: boolean;
      invoicing_active?: boolean;
      metering_concept_v2_active?: boolean;
      go_active?: boolean;
      premium_todos_active?: boolean;
      readonly is_mieterstrom_site?: boolean;
    };
    MeterDataAvailability: {
      feedin_percentage: number | null;
      feedout_percentage: number | null;
      meter_name: string;
      meter_number: string | null;
      meter_id: number;
    };
    EnergyAvailabilityDataType: {
      grid_meters: components["schemas"]["MeterDataAvailability"][];
      calibrated_meters: components["schemas"]["MeterDataAvailability"][];
      scada_meters: components["schemas"]["MeterDataAvailability"][];
      free_floating_meters: components["schemas"]["MeterDataAvailability"][];
    };
    /**
     * @description Form in der die Zustimmung des Direktvermarkters vorliegt
     * @enum {string|null}
     */
    Zustimmungsform: Zustimmungsform | null;
    /** @description A Direktvermarkter as mirrored to/from the external CRM (Hubspot) */
    DirektvermarkterExternal: {
      readonly id: number;
      /** @description Identifier of the Direktvermarkter in Hubspot */
      readonly hubspot_id: string | null;
      readonly name: string;
      /**
       * Format: date-time
       * @description Timestamp since which the Direktvermarkter is considered inactive (dropped from the Hubspot list). Null if currently active.
       */
      readonly date_inactive_since: string | null;
      readonly zustimmungsform: components["schemas"]["Zustimmungsform"];
    };
    /** @description A single Direktvermarkter as sent from Hubspot. Any existing Direktvermarkter whose hubspot_id is not part of the full list sent to the bulk-update endpoint is marked as inactive. */
    DirektvermarkterWriteRequest: {
      /** @description Identifier of the Direktvermarkter in Hubspot */
      hubspot_id: string;
      name: string;
      /** @description A form indicating that the Direktvermarkter has given consent. If omitted, the existing value of an already-known Direktvermarkter is left unchanged; to clear it, send an explicit null. */
      zustimmungsform?: components["schemas"]["Zustimmungsform"];
    };
    /** @description Validation error returned for the Direktvermarkter bulk-update endpoint. The exact shape depends on the kind of failure: per-item field errors for invalid entries, a non_field_errors list if the payload is not a list at all, or a one-element list containing a single message for duplicate hubspot_id/name values or a database-constraint conflict. */
    DirektvermarkterBulkUpdateError:
      | {
          hubspot_id?: string[];
          name?: string[];
          zustimmungsform?: string[];
        }[]
      | {
          non_field_errors: string[];
        }
      | string[];
  };
  responses: never;
  parameters: {
    /** @description UUID of a resource */
    UUIDInPath: string;
    /** @description ID of a resource */
    IDInPath: number;
    /** @description UUID of a credit number range */
    CreditNumberRangeIDInQuery: string;
    /** @description id of a meter */
    MeterIdInQuery: number;
    /** @description First date for a time-limited resource */
    FirstDateInQuery: string;
    /** @description Last date for a time-limited resource */
    LastDateInQuery: string;
    /** @description The unit for the measured data */
    UnitInQuery: string;
    /** @description ID of a task */
    TaskIDInQuery: string;
    /** @description ID of a site */
    SiteInQueryRequired: number;
    /** @description ID of a site */
    SiteIDInQuery: number;
    GeneratorIDInPath: number;
    /** @description ID of a site */
    SiteInQuery: number;
    /** @description ID of a variant */
    VariantIDInQuery: number;
    /** @description Filter generators by the generators accessible to this user instead of the authenticated user. The result is still limited to generators the authenticated user has access to. */
    UserIDInQuery: number;
    /** @description Filter generators by operator (Person ID) of the Direktvermarktungsvertrag */
    VermarktungsvertragCompanyInQuery: number;
    /** @description ID of a site */
    SiteIDInPath: number;
    /** @description UUID of a Project */
    ProjectIDInQuery: string;
    /** @description UUID of a Project */
    ProjectInQuery: string;
    /** @description ID of a company */
    CompanyIDInQuery: number;
    /** @description Maximal number of items per site */
    PageSizeInQuery: number;
    /** @description Number of page, can be set to "last" */
    PageInQuery: number | ComponentsParametersPageInQuery;
    /** @description year as int */
    YearInQuery: number;
    /** @description license of the site */
    SiteLicenseInPath: components["schemas"]["SiteLicense"];
  };
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
  getPersonById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        /** @description ID of a resource */
        ID: components["parameters"]["IDInPath"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description A person */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Person"];
        };
      };
    };
  };
}
export enum PathsApiConfiguratorOperatorsGetParametersQueryActiveFeatures {
  basic = "basic",
  stromsteuer = "stromsteuer",
  paragraph_6_eeg = "paragraph_6_eeg",
  erloesmonitoring = "erloesmonitoring",
  invoices = "invoices",
  guarantee_of_origin = "guarantee_of_origin",
  opticharge = "opticharge",
  ppaaas = "ppaaas"
}
export enum PathsApiAdvancePaymentsCalculateUUIDGetResponses400ContentApplicationJson {
  SlpGridFeesMissing = "SlpGridFeesMissing",
  RlmGridFeesMissing = "RlmGridFeesMissing",
  NeitherHistoricalDataNorPredictionAvailable = "NeitherHistoricalDataNorPredictionAvailable",
  NoDeliveries = "NoDeliveries",
  NoPreviousYearInvoice = "NoPreviousYearInvoice"
}
export enum HistoryLogAction {
  Created = 0,
  Updated = 1,
  Deleted = 2
}
export enum RepresentationType {
  authorized_representative_section_80_ao = "authorized_representative_section_80_ao",
  authorized_representative_section_80_ao_relative_accountant_section_3_4_StBerG = "authorized_representative_section_80_ao_relative_accountant_section_3_4_StBerG",
  universal_successor = "universal_successor",
  manager_groups_without_legal_capacity = "manager_groups_without_legal_capacity",
  manager_estates_section_86_26_BGB = "manager_estates_section_86_26_BGB",
  legal_representative_legal_person = "legal_representative_legal_person",
  legal_representative_natural_person = "legal_representative_natural_person",
  other_representative = "other_representative",
  tax_representative_section_214_ao = "tax_representative_section_214_ao",
  tax_operations_manager_section_62_paragraph_1_StG = "tax_operations_manager_section_62_paragraph_1_StG",
  acquiring_legal_entity = "acquiring_legal_entity",
  authorized_for_disposal_section_35_ao = "authorized_for_disposal_section_35_ao",
  asset_manager_section_34_paragraph_1_ao = "asset_manager_section_34_paragraph_1_ao",
  representative_section_81_ao = "representative_section_81_ao"
}
export enum LegalStructureType {
  adoer = "adoer",
  ag = "ag",
  ausl_Rechtsform = "ausl Rechtsform",
  bga = "bga",
  ek = "ek",
  ev = "ev",
  eg = "eg",
  einzelunternehmen = "einzelunternehmen",
  ewiv = "ewiv",
  freiberufler = "freiberufler",
  gbr = "gbr",
  gmbh = "gmbh",
  kdoer = "kdoer",
  kg = "kg",
  kgaa = "kgaa",
  ohg = "ohg",
  partg = "partg",
  privat = "privat",
  sce = "sce",
  se = "se",
  sonstige = "sonstige",
  stiftung = "stiftung",
  vvag = "vvag"
}
export enum CancellationState {
  ready_to_send = "ready_to_send",
  sent = "sent",
  received = "received"
}
export enum OAuthApplicationScope {
  EnergySeriesRead = "read:series",
  EnergySeriesWrite = "write:series",
  EnergySeriesCreate = "create:series",
  EnergySeriesDelete = "delete:series",
  EnergySeriesEventsRead = "read:series-events",
  LocationDataRead = "read:location",
  LocationDataWrite = "write:location",
  MeterDataRead = "read:meter",
  MeterDataWrite = "write:meter",
  WebhookRead = "read:webhook",
  WebhookWrite = "write:webhook",
  ObersterVertriebspartnerRead = "read:oberster-vertriebspartner",
  ObersterVertriebspartnerWrite = "write:oberster-vertriebspartner",
  PvWirtschaftlichkeitsrechnerAccess = "access:pv-wirtschaftlichkeitsrechner"
}
export enum DirektvermarktungContractTrAbrechnungsmodell {
  PAUSCHAL = "PAUSCHAL",
  SPITZ = "SPITZ",
  SPITZ_LIGHT = "SPITZ_LIGHT"
}
export enum CurrentUserGroups {
  EnergyDataManagement = 68,
  PPA = 169
}
export enum SubMeteringSystem {
  RotorsoftDrehpunkt = "rotorsoft_drehpunkt",
  WisSoftenergy = "wis_softenergy",
  NavigatorSiemens = "navigator_siemens",
  WonderWindguard = "wonder_windguard",
  Qivalo = "qivalo",
  WeoBytemee = "weo_bytemee",
  BreezeGreenbyte = "breeze_greenbyte",
  Wattline = "wattline",
  Metiundo = "metiundo"
}
export enum ImportLogMessage_type {
  Erfolg = "Erfolg",
  Fehler = "Fehler"
}
export enum MeterMedium {
  Electricity = "electricity",
  Gas = "gas",
  Heat = "heat"
}
export enum MeterFrequency {
  TenMinutes = "10min",
  QuarterHour = "15min",
  Hour = "hour",
  Day = "day",
  Month = "month",
  Year = "year"
}
export enum MeterEnergyMeasurementType {
  Single = "lastgang",
  ArbitraryCumulative = "beliebig_z\u00E4hlerstandsgang"
}
export enum MeterMeteringDirection {
  GenerationFeedin = "generation_feedin",
  ConsumptionFeedout = "consumption_feedout",
  BidirectionalMeter = "bidrectional",
  FourQuadrantMeter = "four_quadrant"
}
export enum MeterSubMeteringSystem {
  ManualInput = "manual_input",
  MachineAccount = "machine_account",
  BreezeGreenbyte = "breeze_greenbyte",
  Econ3EconSolutions = "econ_3_econ_solutions",
  EnerboardTengelmann = "enerboard_tengelmann",
  EnergyPlatformBosch = "energy_platform_bosch",
  EvisorLimon = "evisor_limon",
  E3mEmation = "e3m_emation",
  GridvisJanitza = "gridvis_janitza",
  NavigatorSiemens = "navigator_siemens",
  OptimaxAbb = "optimax_abb",
  PowerSystemEnertrag = "power_system_enertrag",
  ReplantIts = "replant_its",
  RotorsoftDrehpunkt = "rotorsoft_drehpunkt",
  SiemensGamesaScadaSolutions = "siemens_gamesa_scada_solutions",
  SipEnercon = "sip_enercon",
  Misc = "misc",
  VobVestas = "vob_vestas",
  WeoBytemee = "weo_bytemee",
  WisSoftenergy = "wis_softenergy",
  WonderWindguard = "wonder_windguard",
  Qivalo = "qivalo",
  Wattline = "wattline",
  Metiundo = "metiundo"
}
export enum YesNoChoice {
  yes = "yes",
  no = "no"
}
export enum VoltageLevel {
  Low = "ns",
  MediumTransformation = "usns",
  Medium = "ms",
  HighTransformation = "usms",
  High = "hs",
  ExtraHighTransformation = "ushs",
  ExtraHigh = "hoes"
}
export enum MeteringConceptMeterFieldsExtraFieldsMeasurement_description {
  Unknown = "unknown",
  GridTransfer = "grid_transfer",
  GenerationMeasurement = "generation_measurement",
  GeneralElectricity = "general_electricity",
  Storage = "storage",
  ElectricMobility = "electric_mobility",
  HeatPump = "heat_pump",
  TenantMeter = "tenant_meter"
}
export enum MeteringConceptMeterFieldsExtraFieldsMeasuring_method {
  Unknown = "unknown",
  ExistingConverterOnSite = "existing_converter_on_site",
  PlannedConverterOnSite = "planned_converter_on_site",
  PlannedConverterViaMsb = "planned_converter_via_msb",
  DirectMeasuring = "direct_measuring"
}
export enum MeteringConceptMeterFieldsExtraFieldsTariff_type {
  Unknown = "unknown",
  Slp = "standard_lastprofil",
  Rlm = "registrierende_leistungsmessung"
}
export enum MeteringConceptMeterFieldsExtraFieldsMeter_billing_relevant_or_submeter {
  MeterBillingRelevant = "meter_billing_relevant",
  Submeter = "submeter"
}
export enum MeteringConceptMeterFieldsExtraFieldsAufhaengung {
  Unknown = "unknown",
  Ehz = "elektronische_haushaltsz\u00E4hler",
  Dpa = "dreipunktaufh\u00E4ngung",
  Hutschiene = "hutschiene"
}
export enum SupplierStatus {
  Full = "full",
  Limited = "limited",
  EigenerzeugerMitErlaubnis = "eigenerzeuger_mit_erlaubnis",
  EigenerzeugerOhneErlaubnispflicht = "eigenerzeuger_ohne_erlaubnispflicht",
  NoStatus = "no_status"
}
export enum FoerderRegime {
  keine_foerderung_in_anspruch_genommen = "keine_foerderung_in_anspruch_genommen",
  foerderung_ausgelaufen = "foerderung_ausgelaufen",
  eeg_fixe_einspeiseverguetung = "eeg_fixe_einspeiseverguetung",
  eeg_ausschreibung = "eeg_ausschreibung",
  eeg_ohne_ausschreibung = "eeg_ohne_ausschreibung",
  eeg_innovationsausschreibung_gleitende_marktpraemie = "eeg_innovationsausschreibung_gleitende_marktpraemie",
  eeg_innovationsausschreibung_fixe_marktpraemie = "eeg_innovationsausschreibung_fixe_marktpraemie",
  kwkg_zuschlag_2016_2020 = "kwkg_zuschlag_2016_2020",
  kwkg_zuschlag_2012 = "kwkg_zuschlag_2012",
  kwkg_ausschreibung = "kwkg_ausschreibung",
  kwkg_zuschlag_2000_2002_2009 = "kwkg_zuschlag_2000_2002_2009"
}
export enum Veraeusserungsform {
  subsidized_direct_marketing = "subsidized_direct_marketing",
  other_direct_marketing = "other_direct_marketing",
  feste_einspeiseverguetung = "feste_einspeiseverguetung"
}
export enum GeneratorType {
  EEGAnlageSolar = "EEGAnlageSolar",
  EEGAnlageBiomasse = "EEGAnlageBiomasse",
  EEGAnlageWind = "EEGAnlageWind",
  EEGAnlageWasser = "EEGAnlageWasser",
  EEGAnlageGSGK = "EEGAnlageGSGK",
  KWKAnlageVerbrennung = "KWKAnlageVerbrennung",
  KWKAnlageBiomasse = "KWKAnlageBiomasse",
  KWKAnlageGSGK = "KWKAnlageGSGK",
  Sonstige = "Sonstige"
}
export enum EEGVersionDetailed {
  BEFORE_EEG_2014 = "BEFORE_EEG_2014",
  EEG_2014 = "EEG_2014",
  EEG_2017 = "EEG_2017",
  EEG_2021 = "EEG_2021",
  EEG_2023 = "EEG_2023",
  EEG_2025 = "EEG_2025"
}
export enum KWKAnlageEnergiesteuerentlastung_paragraph_53a_energiestg {
  keine_steuerentlastung = "keine_steuerentlastung",
  vollstaendige_steuerentlastung = "vollstaendige_steuerentlastung",
  teilweise_steuerentlastung = "teilweise_steuerentlastung",
  vollstaendige_teilweise_entlastung = "vollstaendige_teilweise_entlastung",
  unbekannt = "unbekannt"
}
export enum StromErzeugungsEinheitEinspeisungsart {
  None = "None",
  Volleinspeisung = "Volleinspeisung",
  TeileinspeisungEigenverbrauch = "TeileinspeisungEigenverbrauch"
}
export enum TechnologieVerbrennnungsanlageEnum {
  Verbrennungsmotor = "Verbrennungsmotor",
  Brennstoffzelle = "Brennstoffzelle",
  Stirlingmotor = "Stirlingmotor",
  Dampfmotor = "Dampfmotor",
  ORCOrganicRankineCycleAnlage = "ORCOrganicRankineCycleAnlage",
  GegendruckmaschinemitEntnahme = "GegendruckmaschinemitEntnahme",
  GegendruckmaschineohneEntnahme = "GegendruckmaschineohneEntnahme",
  GasturbinenohneAbhitzekessel = "GasturbinenohneAbhitzekessel",
  GasturbinenmitAbhitzekessel = "GasturbinenmitAbhitzekessel",
  GasturbinenmitnachgeschalteterDampfturbine = "GasturbinenmitnachgeschalteterDampfturbine",
  KondensationsmaschinemitEntnahme = "KondensationsmaschinemitEntnahme",
  KondensationsmaschineohneEntnahme = "KondensationsmaschineohneEntnahme",
  Sonstige = "Sonstige",
  KalinaCycle = "KalinaCycle"
}
export enum SEEBiomasseHauptbrennstoff {
  FesteBiogeneStoffeUndAbfaelleOhneHolz = "FesteBiogeneStoffeUndAbfaelleOhneHolz",
  FluessigeBiogeneStoffeUndAbfaelle = "FluessigeBiogeneStoffeUndAbfaelle",
  AltholzGebrauchtholzHolzmuell = "AltholzGebrauchtholzHolzmuell",
  Biodiesel = "Biodiesel",
  Biogas = "Biogas",
  BiomethanBioerdgas = "BiomethanBioerdgas",
  Biomethanol = "Biomethanol",
  TierUndBlutmehl = "TierUndBlutmehl",
  BrennlaugeSchwarzlaugeSulfitablauge = "BrennlaugeSchwarzlaugeSulfitablauge",
  Deponiegas = "Deponiegas",
  FesteBiogeneStoffe = "FesteBiogeneStoffe",
  Harzoel = "Harzoel",
  WaldHolzhackschnitzelWaldScheitholzWaldKronenholz = "WaldHolzhackschnitzelWaldScheitholzWaldKronenholz",
  Holzreste = "Holzreste",
  HolzspaeneSaegemehl = "HolzspaeneSaegemehl",
  Klaergas = "Klaergas",
  RindeLandschaftspflegeholz = "RindeLandschaftspflegeholz",
  PalmoelPflanzenoel = "PalmoelPflanzenoel",
  PelletsHolz = "PelletsHolz",
  SchleifstaubBiogen = "SchleifstaubBiogen",
  StrohStrohpellets = "StrohStrohpellets",
  Terpentin = "Terpentin",
  Tierfett = "Tierfett",
  HolzgasGasBiomasse = "HolzgasGasBiomasse",
  Holzkohle = "Holzkohle",
  WaldStammholzRundholz = "WaldStammholzRundholz",
  EnergiepflanzenZurVerbrennung = "EnergiepflanzenZurVerbrennung"
}
export enum EnergieTraegerEnum {
  AndereGase = "AndereGase",
  Biomasse = "Biomasse",
  Braunkohle = "Braunkohle",
  Erdgas = "Erdgas",
  Geothermie = "Geothermie",
  Grubengas = "Grubengas",
  Kernenergie = "Kernenergie",
  Klaerschlamm = "Klaerschlamm",
  Mineraloelprodukte = "Mineraloelprodukte",
  NichtBiogenerAbfall = "NichtBiogenerAbfall",
  SolareStrahlungsenergie = "SolareStrahlungsenergie",
  Solarthermie = "Solarthermie",
  Speicher = "Speicher",
  Steinkohle = "Steinkohle",
  Waerme = "Waerme",
  Wind = "Wind",
  Wasser = "Wasser",
  DruckAusGasleitungen = "DruckAusGasleitungen",
  DruckAusWasserleitungen = "DruckAusWasserleitungen",
  Wasserstoff = "Wasserstoff"
}
export enum SEEVerbrennungHauptbrennstoff {
  KohlenwertstoffeAusSteinkohle = "KohlenwertstoffeAusSteinkohle",
  Steinkohlen = "Steinkohlen",
  Steinkohlenbriketts = "Steinkohlenbriketts",
  Steinkohlenkoks = "Steinkohlenkoks",
  Braunkohlenbriketts = "Braunkohlenbriketts",
  Braunkohlenkoks = "Braunkohlenkoks",
  Hartbraunkohlen = "Hartbraunkohlen",
  Rohbraunkohlen = "Rohbraunkohlen",
  StaubUndTrockenkohle = "StaubUndTrockenkohle",
  Wirbelschichtkohle = "Wirbelschichtkohle",
  Dieselkraftstoff = "Dieselkraftstoff",
  HeizoelLeicht = "HeizoelLeicht",
  HeizoelSchwer = "HeizoelSchwer",
  Fluessiggas = "Fluessiggas",
  Petrolkoks = "Petrolkoks",
  Raffineriegas = "Raffineriegas",
  AndereMineraloelprodukte = "AndereMineraloelprodukte",
  ErdgasErdoelgas = "ErdgasErdoelgas",
  GrubengasVerbrennung = "GrubengasVerbrennung",
  HochofengasKonvertergas = "HochofengasKonvertergas",
  Kokereigas = "Kokereigas",
  AndereGase = "AndereGase",
  SonstigeHergestellteGase = "SonstigeHergestellteGase",
  Industrieabfall = "Industrieabfall",
  AbfallHausmuellSiedlungsabfaelle = "AbfallHausmuellSiedlungsabfaelle",
  Dampf = "Dampf",
  Waerme = "Waerme",
  Wasserstoff = "Wasserstoff"
}
export enum MieterstromzuschlagApplicationIntent {
  DoNotApply = "do_not_apply",
  ApplyOrAlreadyApplied = "apply_or_already_applied"
}
export enum PressureStage {
  Low = "low",
  Medium = "medium",
  High = "high"
}
export enum GasQuality {
  Low = "low",
  High = "high"
}
export enum TransmissionSystemOperator {
  Hertz = "50HzT",
  Amprion = "AMPRION",
  Tennet = "TENNET",
  Transnet = "TRANSNET"
}
export enum SupplyType {
  FullSupply = "full",
  PartialSupply = "partial"
}
export enum ConsumerComponentType {
  ProducingIndustry = "prod",
  NonProducingIndustry = "nonprod",
  PublicProperty = "pub",
  Agriculture = "agri",
  PrivateHousehold = "privhouse",
  ElectricChargingStation = "ecs",
  HeatPump = "hp",
  NightStorageHeating = "nsh",
  Other = "other"
}
export enum OperationalPurpose {
  Yes = "yes",
  No = "no"
}
export enum TaxReliefProcesses {
  Electrolysis = "electrolysis",
  GlasOrCeramic = "glas_or_ceramic",
  Metal = "metal",
  ChemicalReduction = "chemical_reduction",
  None = "none"
}
export enum MixKind {
  Green = "green",
  Grey = "grey",
  Individual = "individual",
  SubsidisedTenantSupply = "subsidised_tenant_supply"
}
export enum DeliveryDelivery_kind {
  DirectDelivery = "direct_delivery",
  ForwardingDelivery = "forwarding_delivery"
}
export enum DeliveryPrice_model {
  PassingOn = "passing_on",
  FixedPrice = "fixed_price"
}
export enum DeliveryGrid_usage_billing_model {
  SLP = "slp",
  RLM = "rlm"
}
export enum VermarkterVollmachtUploadSuccessStatus {
  valid = "valid",
  need_confirmation = "need_confirmation",
  rejected = "rejected"
}
export enum VermarkterVollmachtUploadSuccessSignature_resultStatus {
  signed = "signed",
  unsigned = "unsigned",
  detection_failed = "detection_failed"
}
export enum VermarkterVollmachtUploadSuccessDocument_completeStatus {
  sufficient = "sufficient",
  insufficient = "insufficient",
  detection_failed = "detection_failed"
}
export enum InstallmentConfigurationCalculation_base {
  HistoricalMeasurementValues = "historical_measurement_values",
  EstimatedDeliveryAmount = "estimated_delivery_amount",
  EstimatedInstallmentPayment = "estimated_installment_payment"
}
export enum ContractExtension_duration_unit {
  Year = "year",
  Month = "month"
}
export enum ContractCancelation_deadline_unit {
  Year = "year",
  Month = "month",
  Day = "day"
}
export enum ContractCancelation_reference {
  EndOfContract = "end_of_contract",
  EndOfMonth = "end_of_month",
  EndOfYear = "end_of_year"
}
export enum ContractBilling_method_and_period {
  AnnualBasedOnMeasurements = "annual_based_on_measurements",
  MonthlyAdvancePaymentsAndAnnualFinalInvoice = "monthly_advance_payments_and_annual_final_invoice",
  MonthlyBasedOnMeasurements = "monthly_based_on_measurements"
}
export enum ContractPayment_method {
  BankTransfer = "bank_transfer",
  DirectDebit = "direct_debit"
}
export enum ContractDue_date_unit {
  Year = "year",
  Month = "month",
  Day = "day"
}
export enum ContractState {
  InProgress = "in_progress",
  Ready = "ready",
  Cancelled = "cancelled"
}
export enum ContractAdd_price_measuring_point {
  None = "none",
  Total = "total",
  PerMeter = "per_meter"
}
export enum ContractVat_exemption_reason {
  SmallBusinessRegulation = "small_business_regulation",
  ReverseCharge = "reverse_charge",
  Custom = "custom"
}
export enum EnergyRevenuesListItemMarket_premium_revenue_source {
  published = "published",
  projection_monatsmarktwert_for_jahresmarktwert = "projection_monatsmarktwert_for_jahresmarktwert"
}
export enum EnergyRevenuesCellCheckStateColumn {
  vermarktung_volume = "vermarktung_volume",
  vermarktung_net_revenue = "vermarktung_net_revenue",
  vermarktung_fee = "vermarktung_fee",
  net_revenue_minus_fee = "net_revenue_minus_fee",
  market_premium_volume = "market_premium_volume",
  market_premium_revenue = "market_premium_revenue",
  negative_price_revenue = "negative_price_revenue",
  negative_price_volume = "negative_price_volume",
  ausfallarbeit_dva = "ausfallarbeit_dva",
  ausfallarbeit_redispatch = "ausfallarbeit_redispatch",
  ausfallarbeit_foerderung_redispatch = "ausfallarbeit_foerderung_redispatch",
  revenue_dva = "revenue_dva",
  revenue_redispatch = "revenue_redispatch",
  aufwandsersatz_redispatch = "aufwandsersatz_redispatch",
  revenue_foerderung_redispatch = "revenue_foerderung_redispatch",
  dva_entgelt = "dva_entgelt",
  redispatch_entgelt = "redispatch_entgelt"
}
export enum EnergyRevenuesCellCheckStateState {
  inProgress = "inProgress",
  objection = "objection",
  verified = "verified"
}
export enum SiteLicense {
  light = "light",
  standard = "standard",
  premium = "premium"
}
export enum SiteSetupProcessStatus {
  NotConfigured = "not_configured",
  InProgress = "in_progress",
  Completed = "completed"
}
export enum SiteSetupProcessStep {
  NameAndPvPlants = "name_and_pv_plants",
  AddressAndSupplyType = "address_and_supply_type",
  Connection = "connection",
  Consumers = "consumers",
  Tenants = "tenants",
  Meters = "meters"
}
export enum MeterMeasurementType {
  Single = "single",
  ArbitraryCumulative = "arbitrary_cumulative",
  NoMeter = "no_meter"
}
export enum MeteringDirection {
  Erzeugung_Einspeisung = "generation_feedin",
  Verbrauch_Entnahme = "consumption_feedout",
  Zweirichtungszaehler = "bidrectional",
  Vier_Quadranten_Zaehler = "four_quadrant"
}
export enum ConsumerType {
  PrivateHousehold = "private_household",
  Industry = "industry",
  NonProducingIndustry = "non_producing_industry",
  PublicProperty = "public_property",
  Agriculture = "agriculture",
  ElectricChargingStation = "electric_charging_station",
  HeatPump = "heat_pump",
  NightStorageHeating = "night_storage_heating",
  Other = "other"
}
export enum SiteSetupProcessDataStep {
  name_and_pv_plants = "name_and_pv_plants",
  address_and_supply_type = "address_and_supply_type",
  connection = "connection",
  consumers = "consumers",
  tenants = "tenants",
  meters = "meters"
}
export enum SiteSetupProcessDataConnection_meter_energy_data_origin {
  metering_location = "metering_location",
  market_location = "market_location",
  unknown = "unknown"
}
export enum SiteSetupProcessDataMieterstromzuschlag_application_intent {
  DoNotApply = "do_not_apply",
  ApplyOrAlreadyApplied = "apply_or_already_applied"
}
export enum ValidationErrorCode {
  InvalidMastrNumber = "InvalidMastrNumber",
  PvPlantNotFoundInMastr = "PvPlantNotFoundInMastr",
  MastrCommunicationError = "MastrCommunicationError",
  InvalidMeteringLocationNumber = "InvalidMeteringLocationNumber",
  InvalidMarketLocationNumber = "InvalidMarketLocationNumber",
  InvalidConsumerAmount = "InvalidConsumerAmount",
  Required = "Required",
  ConsumerMeterMixed = "ConsumerMeterMixed",
  GeneratorMeterMixed = "GeneratorMeterMixed",
  SingleTenantMeterMixed = "SingleTenantMeterMixed",
  MoreThanOneConsumerUnmeasured = "MoreThanOneConsumerUnmeasured",
  OneConsumerAndSomethingElseUnmeasured = "OneConsumerAndSomethingElseUnmeasured",
  NoParticipant = "NoParticipant",
  IncompatibleLocationNumberDuplication = "IncompatibleLocationNumberDuplication"
}
export enum StartPageTileSize {
  Small = "small",
  Regular = "regular",
  Large = "large"
}
export enum StartPageTileName {
  Invoices = "invoices",
  DeliveredElectricity = "delivered_electricity",
  ProducedElectricity = "produced_electricity",
  Co2Savings = "co2_savings",
  EEG6 = "paragraph_6_eeg",
  ElectricityTax = "stromsteuer",
  OnboardingProgress = "onboarding_progress",
  RegulatoryTodos = "regulatory_todos",
  SiteSetupProcesses = "site_setup_processes"
}
export enum StartPageTileDisplay_mode {
  Show = "show",
  Bookable = "bookable",
  Hide = "hide"
}
export enum OnboardingTodoStatus {
  open = "open",
  done = "done",
  not_relevant = "not_relevant"
}
export enum Abregler {
  betreiber = "betreiber",
  direktvermarkter = "direktvermarkter",
  netzbetreiber = "netzbetreiber"
}
export enum AusfallarbeitTimeSeriesAbrechnungsmodell {
  pauschal = "pauschal",
  spitz = "spitz",
  spitz_light = "spitz-light"
}
export enum Paragraph6EEGCreditResponseState {
  ready_to_send = "ready_to_send",
  cancelled = "cancelled",
  sent = "sent",
  paid = "paid"
}
export enum Paragraph6EEGCreditResponseTodo_alert_state {
  created = "created",
  open = "open",
  not_relevant = "not_relevant",
  none = "none"
}
export enum PaymentIntervallAndBillingMethod {
  annual_based_on_measurements = "annual_based_on_measurements"
}
export enum PaymentMethod {
  bank_transfer = "bank_transfer",
  direct_debit = "direct_debit"
}
export enum DirectMarketingType {
  funded_direct_marketing = "funded_direct_marketing",
  other_direct_marketing = "other_direct_marketing",
  no_direct_marketing = "no_direct_marketing"
}
export enum Paragraph6EEGCreditNumberRangeCounter_reset_interval {
  Annual = "annual",
  Monthly = "monthly"
}
export enum DirektvermarktungContractRemunerationType {
  spot_price_contract = "spot_price_contract",
  monthly_market_value_contract = "monthly_market_value_contract",
  yearly_market_value_contract = "yearly_market_value_contract",
  ppa_contract = "ppa_contract",
  other_verguetung = "other_verguetung"
}
export enum DirektvermarktungContractRedispatchStatusDuldungsfall {
  AUFFORDERUNGSFALL = "AUFFORDERUNGSFALL",
  DULDUNGSFALL = "DULDUNGSFALL"
}
export enum DirektvermarktungContractRedispatchBilanzierungsmodell {
  PLANWERTMODELL = "PLANWERTMODELL",
  PROGNOSEMODELL = "PROGNOSEMODELL",
  PROGNOSE_MIT_PLANUNGSDATENLIEFERUNG = "PROGNOSE_MIT_PLANUNGSDATENLIEFERUNG",
  PROGNOSE_MIT_PROBEPLANUNGSDATENLIEFERUNG = "PROGNOSE_MIT_PROBEPLANUNGSDATENLIEFERUNG"
}
export enum GapsInMeteringDataMeasurand {
  positive = "positive",
  negative = "negative",
  loss_of_work = "loss_of_work"
}
export enum DataImportRequestStatus {
  Open = "OPEN",
  InProgress = "IN_PROGRESS",
  Success = "SUCCESSFUL",
  Error = "FAILED",
  Stopped = "STOPPED",
  Rejected = "REJECTED"
}
export enum DataImportRequestType {
  METERING = "METERING_DATA",
  REDISPATCH = "REDISPATCH_DATA"
}
export enum TodosUpdateUserDecisionsTodosUser_decision {
  open = "open",
  rejected = "rejected",
  confirmed = "confirmed",
  unclear = "unclear"
}
export enum RegulatoryDutyCategory {
  OwnConsumption = "Eigenverbrauch",
  DirectDelivery = "Direktlieferung",
  PlantOperation = "Anlagenbetrieb",
  PeakBalancingTax = "StromSt-Spitzenausgleich",
  PowerConsumption = "Stromverbrauch",
  Premium = "Premium",
  ElectricityPriceBrake = "Strompreisbremse",
  EnergyPriceBrake = "Energiepreisbremse",
  Other = "Sonstiges"
}
export enum TodoDetailUser_decision {
  open = "open",
  rejected = "rejected",
  confirmed = "confirmed",
  unclear = "unclear"
}
export enum TodoDetailSystem_decision {
  applicable = "applicable",
  not_applicable = "not_applicable",
  cant_tell = "cant_tell",
  need_more_information = "need_more_information"
}
export enum TodoDetailCategory {
  onboarding = "onboarding",
  regulatory_duty = "regulatory_duty",
  other = "other"
}
export enum TodoDetailCluster {
  regulatory_duty = "regulatory_duty",
  assessment_profitability = "assessment_profitability",
  planning_and_realisation = "planning_and_realisation",
  metering_concept_and_ops = "metering_concept_and_ops",
  direct_marketing = "direct_marketing",
  power_supply_to_tenant = "power_supply_to_tenant",
  project_finalisation = "project_finalisation",
  onboarding = "onboarding",
  other = "other"
}
export enum TodoDetailPriority {
  high = "high",
  medium = "medium",
  low = "low",
  unknown = "unknown"
}
export enum TodoDetailGroup {
  regulatory_duties = "regulatory_duties",
  project_preparation = "project_preparation"
}
export enum Zustimmungsform {
  generell = "generell",
  einzelfallentscheidung = "einzelfallentscheidung",
  manueller_upload = "manueller_upload",
  keine_zustimmung = "keine_zustimmung",
  negativ_liste = "negativ_liste"
}
export enum ComponentsParametersPageInQuery {
  last = "last"
}
